package com.evoapps.evoshift.ui.roster

import evoshift.composeapp.generated.resources.event_badge

import evoshift.composeapp.generated.resources.remote_badge

import androidx.compose.material.icons.filled.Event

import androidx.compose.material.icons.filled.Home

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.ProvideScreenColors
import com.evoapps.evoshift.widgets.OnDialog
import com.evoapps.evoshift.viewmodels.GridCell
import com.evoapps.evoshift.viewmodels.GridEditKind
import com.evoapps.evoshift.ui.adaptive.ListVerticalScrollbar
import com.evoapps.evoshift.ui.adaptive.RowHorizontalScrollbar
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.platform.testTag
import evoshift.composeapp.generated.resources.roster_picker_guest_from
import evoshift.composeapp.generated.resources.roster_grid_added
import evoshift.composeapp.generated.resources.roster_grid_moved
import evoshift.composeapp.generated.resources.roster_grid_unassigned
import androidx.compose.material3.minimumInteractiveComponentSize
import androidx.compose.material3.Button
import androidx.compose.material.icons.filled.PersonAdd
import androidx.compose.ui.semantics.contentDescription
import evoshift.composeapp.generated.resources.roster_day_assign
import evoshift.composeapp.generated.resources.roster_picker_title
import evoshift.composeapp.generated.resources.roster_import_title
import evoshift.composeapp.generated.resources.roster_import_empty_hint
import evoshift.composeapp.generated.resources.roster_import_empty_action
import androidx.compose.material.icons.filled.UploadFile
import evoshift.composeapp.generated.resources.copy_tool_title
import evoshift.composeapp.generated.resources.roster_unfilled_count
import org.jetbrains.compose.resources.pluralStringResource
import com.evoapps.evoshift.ui.theme.MotionVisibility
import androidx.compose.foundation.layout.PaddingValues
import com.evoapps.evoshift.domain.model.RosterStatus
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.material3.LocalTextStyle
import com.evoapps.evoshift.ui.theme.animatedFraction
import com.evoapps.evoshift.ui.theme.AnimatedAmountText
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.ui.theme.pendingFade
import com.evoapps.evoshift.ui.theme.motionContentSize
import com.evoapps.evoshift.ui.theme.MotionContent
import androidx.compose.runtime.key
import com.evoapps.evoshift.domain.util.AppClock
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.map
import com.evoapps.evoshift.domain.explain.Breakdown

import com.evoapps.evoshift.ui.finance.MissingPayBanner
import com.evoapps.evoshift.viewmodels.MissingPayScope

import evoshift.composeapp.generated.resources.at_work_break_since
import evoshift.composeapp.generated.resources.at_work_breaks_total
import evoshift.composeapp.generated.resources.shift_break_add
import evoshift.composeapp.generated.resources.shift_break_remove
import evoshift.composeapp.generated.resources.shift_breaks
import com.evoapps.evoshift.domain.model.ShiftBreak
import com.evoapps.evoshift.domain.model.BreakRules
import com.evoapps.evoshift.domain.model.BreakProblem
import com.evoapps.evoshift.domain.model.ClockSource
import com.evoapps.evoshift.ui.util.breakProblemText
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.material.icons.filled.Delete
import androidx.compose.ui.platform.testTag
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.ui.unit.Dp
import com.evoapps.evoshift.widgets.ContextMenuArea
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.navigation.AppShortcut
import com.evoapps.evoshift.navigation.ShortcutHandler
import evoshift.composeapp.generated.resources.context_assign_shift
import evoshift.composeapp.generated.resources.context_edit_shift
import evoshift.composeapp.generated.resources.context_unassign_shift
import evoshift.composeapp.generated.resources.context_show_day
import com.evoapps.evoshift.domain.model.DayStaffAlert
import com.evoapps.evoshift.domain.model.ShiftLeadRule
import com.evoapps.evoshift.domain.staffing.DayStaffingHint
import com.evoapps.evoshift.ui.util.StaffingChip
import com.evoapps.evoshift.ui.util.StaffingHintLines
import com.evoapps.evoshift.viewmodels.DEFAULT_CURRENCY
import com.evoapps.evoshift.domain.model.Engagement
import com.evoapps.evoshift.domain.model.StaffReadiness
import com.evoapps.evoshift.ui.user.ExpiringAmber
import com.evoapps.evoshift.ui.user.StaffBadges
import com.evoapps.evoshift.ui.user.lowerLabel
import com.evoapps.evoshift.ui.user.text
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material.icons.filled.Gavel
import com.evoapps.evoshift.domain.schedule.LabourWarning
import com.evoapps.evoshift.domain.schedule.RosterIssue
import evoshift.composeapp.generated.resources.issue_shift_marks
import evoshift.composeapp.generated.resources.issue_person_marks
import com.evoapps.evoshift.ui.util.text
import evoshift.composeapp.generated.resources.roster_labour_code
import evoshift.composeapp.generated.resources.roster_labour_code_title
import evoshift.composeapp.generated.resources.roster_labour_code_hint
import evoshift.composeapp.generated.resources.roster_labour_code_none
import evoshift.composeapp.generated.resources.roster_shift_labour_warning
import androidx.compose.material.icons.filled.School
import androidx.compose.material.icons.filled.SupervisorAccount
import evoshift.composeapp.generated.resources.conflict_staff_blocked
import evoshift.composeapp.generated.resources.conflict_staff_expired
import evoshift.composeapp.generated.resources.ok
import evoshift.composeapp.generated.resources.staff_checks_title
import evoshift.composeapp.generated.resources.staff_status_expired
import com.evoapps.evoshift.domain.legal.DayClosure
import com.evoapps.evoshift.ui.util.closureLabel
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.stateDescription
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import evoshift.composeapp.generated.resources.roster_next_month
import evoshift.composeapp.generated.resources.day_closed
import evoshift.composeapp.generated.resources.roster_previous_month
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.widgets.LocalContextSwitcher
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import com.evoapps.evoshift.ui.adaptive.handCursor
import evoshift.composeapp.generated.resources.roster_publishing_hint
import evoshift.composeapp.generated.resources.roster_publishing
import androidx.compose.material.icons.filled.CalendarToday
import androidx.compose.material.icons.filled.Publish
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.ui.text.input.ImeAction
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.ErrorOnNavy
import com.evoapps.evoshift.widgets.MessageEffect
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.RoleField
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.parseClockTime
import evoshift.composeapp.generated.resources.dialog_section_assignment
import evoshift.composeapp.generated.resources.schedule_no_shifts
import evoshift.composeapp.generated.resources.time_same_start_end
import evoshift.composeapp.generated.resources.roster_shift_cost
import evoshift.composeapp.generated.resources.roster_shift_no_rate
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.roster_delete_shift
import evoshift.composeapp.generated.resources.roster_delete_shift_title
import evoshift.composeapp.generated.resources.roster_delete_shift_text_assigned
import evoshift.composeapp.generated.resources.roster_delete_shift_text_unassigned
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.material.icons.filled.Block
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.SolidColor
import com.evoapps.evoshift.ui.CardMetallicBrush
import com.evoapps.evoshift.ui.DarkMetallicBackgroundBrush
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.viewmodels.isPending
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import evoshift.composeapp.generated.resources.print_working_time
import evoshift.composeapp.generated.resources.print_roster
import com.evoapps.evoshift.ui.reports.PrintWorkingTimeDialog
import com.evoapps.evoshift.ui.reports.PrintPerson
import androidx.compose.material.icons.filled.Print
import androidx.compose.material.icons.filled.Email
import evoshift.composeapp.generated.resources.email_roster
import evoshift.composeapp.generated.resources.auto_assign
import androidx.compose.material.icons.filled.AutoFixHigh
import evoshift.composeapp.generated.resources.roster_publish_leftovers
import evoshift.composeapp.generated.resources.roster_publish_open_note
import evoshift.composeapp.generated.resources.roster_publish_keep_open
import evoshift.composeapp.generated.resources.roster_publish_remove
import evoshift.composeapp.generated.resources.roster_summary_open
import evoshift.composeapp.generated.resources.roster_open_shift_toggle
import evoshift.composeapp.generated.resources.roster_open_shift_hint
import evoshift.composeapp.generated.resources.roster_open_shift_label
import evoshift.composeapp.generated.resources.roster_open_shift_claimed
import com.evoapps.evoshift.domain.model.SwapStatus
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.domain.usecase.AssignUserToShiftUseCase
import com.evoapps.evoshift.domain.model.ConflictType
import evoshift.composeapp.generated.resources.conflict_unavailable
import evoshift.composeapp.generated.resources.roster_availability_no_answer
import evoshift.composeapp.generated.resources.conflict_same_owner
import evoshift.composeapp.generated.resources.conflict_other_company
import evoshift.composeapp.generated.resources.conflict_generic
import evoshift.composeapp.generated.resources.employee
import evoshift.composeapp.generated.resources.roster_actual_range
import evoshift.composeapp.generated.resources.kiosk_via_qr
import evoshift.composeapp.generated.resources.kiosk_via_tablet
import evoshift.composeapp.generated.resources.kiosk_synced_late
import evoshift.composeapp.generated.resources.roster_skills_list
import evoshift.composeapp.generated.resources.roster_shift_unsupervised
import evoshift.composeapp.generated.resources.unknown
import com.evoapps.evoshift.ui.util.label
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.domain.model.DayWeather
import com.evoapps.evoshift.ui.util.WeatherAttribution
import com.evoapps.evoshift.ui.util.WeatherBadge
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.CompositionLocalProvider
import com.evoapps.evoshift.domain.model.DaySpecials
import com.evoapps.evoshift.ui.util.SpecialDayMarker
import androidx.compose.foundation.combinedClickable
import evoshift.composeapp.generated.resources.local_event_add
import evoshift.composeapp.generated.resources.local_event_edit_named
import com.evoapps.evoshift.ui.util.dayAndDate
import evoshift.composeapp.generated.resources.done
import evoshift.composeapp.generated.resources.roster_published
import evoshift.composeapp.generated.resources.roster_summary_filled
import evoshift.composeapp.generated.resources.roster_summary_total_hours
import com.evoapps.evoshift.domain.util.plannedTimeRange
import evoshift.composeapp.generated.resources.roster_unassigned
import evoshift.composeapp.generated.resources.roster_employee
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Message
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.PrimaryStyle
import com.evoapps.evoshift.viewmodels.RosterPublishState
import com.evoapps.evoshift.viewmodels.rosterPublishState
import androidx.compose.material.icons.filled.TaskAlt
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material.icons.filled.Event
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import evoshift.composeapp.generated.resources.top_bar_more
import evoshift.composeapp.generated.resources.roster_day_copy_this
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarResult
import evoshift.composeapp.generated.resources.copy_applied
import evoshift.composeapp.generated.resources.copy_day_menu_copy
import evoshift.composeapp.generated.resources.copy_days_menu_paste
import evoshift.composeapp.generated.resources.copy_days_menu_paste_selected
import evoshift.composeapp.generated.resources.copy_days_menu_copy_selected
import evoshift.composeapp.generated.resources.copy_undo
import evoshift.composeapp.generated.resources.roster_shift_deleted
import com.evoapps.evoshift.widgets.helpAction
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.platform.LocalDensity
import com.evoapps.evoshift.ui.adaptive.PostureAwareScaffold
import com.evoapps.evoshift.ui.adaptive.DetailPaneBack
import com.evoapps.evoshift.ui.adaptive.WindowWidthClass
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import kotlinx.coroutines.launch
import kotlin.math.roundToInt
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.foundation.text.TextAutoSize
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.Availability
import com.evoapps.evoshift.domain.model.AvailabilitySlot
import com.evoapps.evoshift.domain.model.BusyElsewhere
import com.evoapps.evoshift.domain.schedule.ElsewhereIssue
import evoshift.composeapp.generated.resources.busy_elsewhere_same_owner
import evoshift.composeapp.generated.resources.busy_elsewhere_other_employer
import evoshift.composeapp.generated.resources.busy_elsewhere_rest_note
import com.evoapps.evoshift.domain.model.AvailabilityStatus
import com.evoapps.evoshift.domain.model.DayPreference
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.Interview
import evoshift.composeapp.generated.resources.interview_title
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.domain.budget.BudgetEffect
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.util.calculateDurationHours
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.viewmodels.RosterDetailViewModel
import com.evoapps.evoshift.viewmodels.RosterDetailUiState
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.actual_work_section
import evoshift.composeapp.generated.resources.roster_actual_time
import evoshift.composeapp.generated.resources.roster_add_additional
import evoshift.composeapp.generated.resources.roster_all_filled
import evoshift.composeapp.generated.resources.roster_assign_role_time
import evoshift.composeapp.generated.resources.roster_assign_shift
import evoshift.composeapp.generated.resources.roster_assign_shift_to
import evoshift.composeapp.generated.resources.roster_assigned_shifts
import evoshift.composeapp.generated.resources.roster_build_title
import evoshift.composeapp.generated.resources.roster_build_title_loading
import evoshift.composeapp.generated.resources.roster_cancel_addition
import evoshift.composeapp.generated.resources.roster_conflicts
import evoshift.composeapp.generated.resources.roster_assign_anyway
import evoshift.composeapp.generated.resources.roster_create_custom
import evoshift.composeapp.generated.resources.roster_end_time
import evoshift.composeapp.generated.resources.roster_from_skeleton
import evoshift.composeapp.generated.resources.roster_from_templates
import evoshift.composeapp.generated.resources.roster_no_employee
import evoshift.composeapp.generated.resources.roster_no_open_skeleton_shifts
import evoshift.composeapp.generated.resources.roster_unfilled_short
import evoshift.composeapp.generated.resources.roster_open_short
import evoshift.composeapp.generated.resources.roster_planned_time
import evoshift.composeapp.generated.resources.roster_publish
import evoshift.composeapp.generated.resources.roster_publish_changes
import evoshift.composeapp.generated.resources.roster_published_state
import evoshift.composeapp.generated.resources.roster_save_template
import evoshift.composeapp.generated.resources.roster_shift_details
import evoshift.composeapp.generated.resources.roster_from
import evoshift.composeapp.generated.resources.roster_to
import evoshift.composeapp.generated.resources.roster_start_time
import evoshift.composeapp.generated.resources.roster_total_hours
import evoshift.composeapp.generated.resources.roster_planned_hours
import evoshift.composeapp.generated.resources.roster_planned_hours_of
import evoshift.composeapp.generated.resources.roster_unassign
import evoshift.composeapp.generated.resources.roster_edit_shift
import evoshift.composeapp.generated.resources.roster_unassigned_shifts
import evoshift.composeapp.generated.resources.roster_unfilled
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.skeleton_no_role
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month
import org.jetbrains.compose.resources.stringResource
import androidx.compose.material.icons.automirrored.filled.OpenInNew
import com.evoapps.evoshift.shell.WindowTarget
import com.evoapps.evoshift.shell.rememberOpenInNewWindow
import evoshift.composeapp.generated.resources.open_in_new_window

@OptIn(
    ExperimentalMaterial3Api::class,
    ExperimentalLayoutApi::class,
    ExperimentalFoundationApi::class
)
@Composable
fun RosterBuilderScreen(
    viewModel: RosterDetailViewModel,
    onNavigateBack: () -> Unit,
    onShiftClick: (String) -> Unit,
    /** Opens with this day's shifts in the day sheet. */
    initialDay: LocalDate? = null,
    /** SH-217: "Import the roster from a spreadsheet" into this month (null: not offered). */
    onImport: ((rosterId: String) -> Unit)? = null,
    /** SH-219: opens with auto-assign or the e-mail dialog ([RosterDetailAction]), from the start path. */
    initialAction: String? = null
) {
    // SH-152: the cost explanations (budget, shift cost) name the team's people.
    val team by remember(viewModel) { viewModel.uiState.map { it.availableEmployees } }.collectAsState(emptyList())
    // SH-253: and the people who left, by the name their shifts carry (resolved from their profiles).
    val shiftNames by remember(viewModel) {
        viewModel.uiState.map { state ->
            state.shiftsByDate.values.flatten().mapNotNull { s -> s.userId?.let { id -> s.userDisplayName?.takeIf { it.isNotBlank() }?.let { id to it } } }.toMap()
        }.distinctUntilChanged()
    }.collectAsState(emptyMap())
    val names = remember(team, shiftNames) { shiftNames + team.filter { it.displayName.isNotBlank() }.associate { it.uid to it.displayName } }
    androidx.compose.runtime.CompositionLocalProvider(com.evoapps.evoshift.ui.finance.LocalExplainNames provides names) {
        RosterBuilderScreenBody(viewModel, onNavigateBack, onShiftClick, initialDay, onImport, initialAction)
    }
}

@OptIn(
    ExperimentalMaterial3Api::class,
    ExperimentalLayoutApi::class,
    ExperimentalFoundationApi::class
)
@Composable
private fun RosterBuilderScreenBody(
    viewModel: RosterDetailViewModel,
    onNavigateBack: () -> Unit,
    onShiftClick: (String) -> Unit,
    initialDay: LocalDate?,
    onImport: ((rosterId: String) -> Unit)?,
    initialAction: String?
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // SH-227: the month's events and special days, and the event dialog.
    val specials by viewModel.specialDays.state.collectAsStateWithLifecycle()
    val hoursByUser = remember(state.shiftsByDate) { state.plannedHoursByUserId }
    // Once per screen, not once per cell (hundreds of clock + time zone reads per frame).
    val today = remember { today() }
    val snackbarHostState = remember { SnackbarHostState() }
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    // SH-158: actions answer in the hand (a tick for a choice, a confirming buzz for a delete).
    val feedback = com.evoapps.evoshift.widgets.LocalActionFeedback.current

    // SH-167: the open day lives in the view model, so assigning in its sheet keeps it open.
    val showDayDetails = state.selectedDate
    LaunchedEffect(initialDay) { initialDay?.let { viewModel.onDateSelected(it) } }
    // SH-112: the month's labour-code warnings, per person.
    var showLabourCode by remember { mutableStateOf(false) }
    // SH-169: the grid's keyboard cell, selection, cell popover and drag (wide windows).
    val grid = remember { RosterGridState() }
    val gridListState = rememberLazyListState()
    // Adding unassigned shifts and deleting shifts from the day's details (a month being built).
    fun dayEditing(date: LocalDate): DayShiftEditing? = if (!state.canEditShifts) null else DayShiftEditing(
        templates = state.shiftTemplates,
        onAddFromTemplate = { template -> viewModel.createShiftFromTemplate(date, template) },
        onAddCustom = { start, end, role ->
            viewModel.createShiftFromTemplate(
                date,
                ShiftTemplate(id = "custom", name = role.orEmpty(), startTime = start, endTime = end, role = role, skills = emptyList())
            )
        },
        // SH-167: unassigned shifts (and drafts) go at once with Undo; assigned ones of a published month ask first.
        onDelete = { shift: Shift -> if (viewModel.requestDelete(shift)) feedback.confirm() }.takeIf { viewModel.deleteAvailable },
        budgetEffect = state.budgetStatus?.let { _ -> { hours: Double -> state.budgetEffect(date, null, null, hours) } },
        currency = state.currency,
        shiftCost = state.budget?.let { _ -> { hours: Double -> state.shiftCostExplained(null, null, hours) } },
        availableRoles = state.availableRoles,
        // SH-204: the add-shift dialog (wide) / sheet (phone): several templates, custom times, a person.
        adding = AddShiftSupport(
            date = date,
            onAdd = { templates, userId -> viewModel.addShiftsToDay(date, templates, userId) },
            candidates = { drafts -> state.addShiftCandidates(date, drafts) },
            guests = { drafts -> state.addShiftGuestCandidates(date, drafts) },
            availabilitySlots = state.availabilitySlots,
            costFor = state.budget?.let { _ -> { userId: String?, hours: Double -> state.shiftCostExplained(null, userId, hours) } }
        )
    )

    // SH-167: "Assign" on the day's unassigned shifts: the people in the same sheet, one tap assigns
    // (a tick, the shift sliding into the assigned list) and the day stays open for the next one.
    fun dayAssigning(): DayAssigning? = if (!state.canEditShifts) null else DayAssigning(
        pickerShiftId = state.pickerShiftId,
        candidates = { id -> state.assignCandidates(id) },
        availabilitySlots = state.availabilitySlots,
        onOpen = { shift -> viewModel.openPicker(shift.id) },
        onPick = { userId ->
            viewModel.assignFromPicker(userId)
            feedback.tick()
        },
        onClose = { viewModel.closePicker() },
        // SH-267: "From your other workplaces".
        guests = { id -> state.guestCandidates(id) }
    )

    val horizontalScrollState = rememberScrollState()

    // SH-102: the week pager below a foldable's hinge scrolls the grid (or the phone's day list);
    // while that controls pane shows, it holds the day's shifts and the main actions, so the top
    // bar and the bottom sheet leave them out.
    val dayListState = rememberLazyListState()
    var dayCellPx by remember { mutableStateOf(0f) }
    var postureControlsShown by remember { mutableStateOf(false) }
    val pagerScope = rememberCoroutineScope()

    // SH-263: a published month's changes the team does not see yet (the Publish button's rule):
    // the banner over the grid, and "Show" highlights them until they are published.
    val unpublishedIds = remember(state.shiftsByDate, state.roster?.status, state.capabilities) { state.unpublishedShiftIds }
    val unpublishedRemovals = state.unpublishedRemovals
    val unpublishedCount = unpublishedIds.size + unpublishedRemovals.size
    var showUnpublished by androidx.compose.runtime.saveable.rememberSaveable { mutableStateOf(false) }
    if (showUnpublished && unpublishedCount == 0) SideEffect { showUnpublished = false }

    // SH-188: shown, then cleared, so the same failure twice in a row is reported twice.
    MessageEffect(state.error, snackbarHostState, onShown = viewModel::dismissError)

    // SH-53: how many shifts auto-assign filled (cleared after it was shown, never before: clearing
    // first would restart the effect and cancel the snackbar).
    MessageEffect(state.notice, snackbarHostState, onShown = viewModel::dismissNotice)

    // SH-158: "Shift deleted." with Undo (puts the shift back).
    state.deleteUndo?.let { undo ->
        val deletedText = stringResource(Res.string.roster_shift_deleted)
        val undoLabel = stringResource(Res.string.copy_undo)
        LaunchedEffect(undo) {
            val result = snackbarHostState.showSnackbar(deletedText, actionLabel = undoLabel, withDismissAction = true, duration = SnackbarDuration.Long)
            if (result == SnackbarResult.ActionPerformed) viewModel.undoDelete() else viewModel.dismissDeleteUndo()
        }
    }

    // SH-114: how many shifts were copied, with Undo (removes exactly those).
    state.copyUndo?.let { undo ->
        val copiedText = stringResource(Res.string.copy_applied, undo.shiftIds.size)
        val undoLabel = stringResource(Res.string.copy_undo)
        LaunchedEffect(undo) {
            // SH-171: a notice still showing ("Day copied…") makes way for the copy's Undo.
            snackbarHostState.currentSnackbarData?.dismiss()
            val result = snackbarHostState.showSnackbar(copiedText, actionLabel = undoLabel, withDismissAction = true, duration = SnackbarDuration.Long)
            if (result == SnackbarResult.ActionPerformed) viewModel.undoCopy() else viewModel.dismissCopyUndo()
        }
    }

    // SH-169: the grid's last edit (Delete, a drag, a template on selected cells, a paste) with
    // Undo; Ctrl/Cmd+Z does the same (and undoes a delete or a copy while theirs shows).
    state.gridUndo?.let { undo ->
        val text = when (undo.kind) {
            GridEditKind.UNASSIGNED -> stringResource(Res.string.roster_grid_unassigned, undo.count)
            GridEditKind.MOVED -> stringResource(Res.string.roster_grid_moved)
            GridEditKind.ADDED -> stringResource(Res.string.roster_grid_added, undo.count)
        }
        val undoLabel = stringResource(Res.string.copy_undo)
        LaunchedEffect(undo) {
            val result = snackbarHostState.showSnackbar(text, actionLabel = undoLabel, withDismissAction = true, duration = SnackbarDuration.Long)
            if (result == SnackbarResult.ActionPerformed) viewModel.undoGrid() else viewModel.dismissGridUndo()
        }
    }
    ShortcutHandler(AppShortcut.UNDO, enabled = state.gridUndo != null || state.deleteUndo != null || state.copyUndo != null) {
        if (viewModel.undoLast()) feedback.tick()
    }

    // SH-205: "Copy shifts": days, weeks and ranges (also from last month) onto days of this month.
    state.copyTool?.let { copyTool ->
        CopyShiftsDialog(
            state = copyTool,
            onTapSource = viewModel::copyToolTapSource,
            onPickWeek = viewModel::copyToolPickWeek,
            onWholePreviousMonth = viewModel::copyToolWholePreviousMonth,
            onShowMonth = viewModel::copyToolShowMonth,
            onNext = viewModel::copyToolNext,
            onBack = viewModel::copyToolBack,
            onTapTarget = viewModel::copyToolTapTarget,
            onToggleTargets = viewModel::copyToolToggleTargets,
            onClearTargets = viewModel::copyToolClearTargets,
            onRepeat = viewModel::copyToolRepeat,
            onPlannedDays = viewModel::setCopyPlannedDays,
            onCopy = {
                viewModel.applyCopy()
                feedback.tick()
            },
            onDismiss = viewModel::dismissCopy
        )
    }

    state.autoAssign?.let { autoAssign ->
        AutoAssignSheet(
            state = autoAssign,
            onToggle = viewModel::toggleAutoAssignment,
            onSelectAll = viewModel::setAllAutoAssignments,
            onApply = viewModel::applyAutoAssign,
            onDismiss = viewModel::dismissAutoAssign,
            onSuggestWithAi = viewModel::suggestAutoAssignWithAi
        )
    }

    state.publishConfirmation?.let { confirmation ->
        EvoDialog(
            title = stringResource(Res.string.roster_publish),
            icon = Icons.Default.Publish,
            onDismiss = { viewModel.cancelPublish() },
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.roster_publish_keep_open), { viewModel.confirmPublish(markLeftoversOpen = true) }),
            neutral = DialogAction(stringResource(Res.string.roster_publish_remove), { viewModel.confirmPublish() }, destructive = true),
            bodyArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                stringResource(Res.string.roster_publish_leftovers, confirmation.leftoverShifts),
                style = MaterialTheme.typography.bodyLarge,
                color = Color.White.copy(alpha = 0.85f)
            )
            if (confirmation.openShifts > 0) {
                Text(stringResource(Res.string.roster_publish_open_note, confirmation.openShifts), color = Color.White.copy(alpha = 0.6f))
            }
        }
    }

    // Soft validation: the person is unavailable, already on another shift, or (SH-47) their
    // medical exam or OHS training has expired; the manager decides, unless the workplace blocks.
    state.pendingConflict?.let { conflict ->
        if (conflict.details.blocked) {
            EvoDialog(
                title = stringResource(Res.string.staff_checks_title),
                icon = Icons.Default.Warning,
                onDismiss = { viewModel.cancelConflict() },
                width = DialogWidth.Compact,
                confirm = DialogAction(stringResource(Res.string.ok), { viewModel.cancelConflict() }),
                dismiss = null
            ) {
                Text(conflictText(conflict.details), style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f))
                Text(stringResource(Res.string.conflict_staff_blocked), style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.7f))
            }
        } else {
            EvoConfirmDialog(
                title = stringResource(
                    if (conflict.details.conflictType == ConflictType.EXPIRED_STAFF_CHECK) Res.string.staff_checks_title else Res.string.roster_conflicts
                ),
                text = conflictText(conflict.details),
                confirmLabel = stringResource(Res.string.roster_assign_anyway),
                onConfirm = {
                    val newShift = conflict.newShift
                    if (newShift != null) viewModel.createShiftFromTemplate(newShift.first, newShift.second, conflict.userId, force = true)
                    else viewModel.assignShift(conflict.shiftId, conflict.userId, force = true, undo = conflict.undo)
                },
                onDismiss = { viewModel.cancelConflict() },
                icon = Icons.Default.Warning
            )
        }
    }

    if (showLabourCode) {
        LabourCodeDialog(state, onDismiss = { showLabourCode = false })
    }

    // Publishing writes the whole month; block the screen until it is done so it is visible.
    if (state.isPublishing) {
        EvoDialog(
            title = stringResource(Res.string.roster_publishing),
            icon = Icons.Default.Publish,
            onDismiss = {},
            width = DialogWidth.Compact,
            dismissible = false,
            dismiss = null
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                CircularProgressIndicator(modifier = Modifier.size(28.dp), color = DarkGold, strokeWidth = 3.dp)
                Spacer(Modifier.width(16.dp))
                Text(stringResource(Res.string.roster_publishing_hint), color = Color.White.copy(alpha = 0.85f))
            }
        }
    }

    state.publishSuccessData?.let { success ->
        val close = {
            viewModel.dismissPublishSuccess()
            onNavigateBack()
        }
        EvoDialog(
            title = stringResource(Res.string.roster_published),
            subtitle = "${monthName(success.month)} ${success.year}",
            icon = Icons.Default.CheckCircle,
            onDismiss = close,
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.done), close),
            dismiss = null
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(16.dp))
                    .background(Color.White.copy(alpha = 0.06f))
                    .padding(vertical = 16.dp),
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                PublishStat("${success.totalHours.toInt()}h", stringResource(Res.string.roster_summary_total_hours), Color.White)
                PublishStat("${success.filledShifts}/${success.totalShifts}", stringResource(Res.string.roster_summary_filled), Color.White)
                if (success.openShifts > 0) {
                    PublishStat("${success.openShifts}", stringResource(Res.string.roster_summary_open), LightGold)
                }
            }
        }
    }
    // SH-98: the labels of the grid's right-click menus, read once for the whole grid.
    val cellMenuLabels = ShiftCellMenuLabels(
        assign = stringResource(Res.string.context_assign_shift),
        edit = stringResource(Res.string.context_edit_shift),
        unassign = stringResource(Res.string.context_unassign_shift),
        showDay = stringResource(Res.string.context_show_day)
    )
    val addEventLabel = stringResource(Res.string.local_event_add)
    // The menu is built outside composition: the label with a marker the event's name replaces.
    val editEventLabel = stringResource(Res.string.local_event_edit_named, EVENT_NAME_MARK)
    val dayHeaderMenuLabels = DayHeaderMenuLabels(
        copyThis = stringResource(Res.string.copy_day_menu_copy),
        copySelected = stringResource(Res.string.copy_days_menu_copy_selected),
        pasteHere = stringResource(Res.string.copy_days_menu_paste),
        pasteSelected = stringResource(Res.string.copy_days_menu_paste_selected),
        showDay = stringResource(Res.string.context_show_day),
        addEvent = addEventLabel,
        editEvent = { name -> editEventLabel.replace(EVENT_NAME_MARK, name) }
    )
    var showPrint by remember { mutableStateOf(false) }
    val printRoster = state.roster
    // SH-158: the team in name order, once per change of the team (not on every recomposition).
    val printPeople = remember(state.availableEmployees) {
        state.availableEmployees.map { PrintPerson(it.uid, it.displayName) }.sortedBy { it.name.lowercase() }
    }
    // SH-261: "Print roster", the whole team's month or a week for the wall.
    var showPrintRoster by remember { mutableStateOf(false) }
    val rosterPrintable = state.roster != null && state.capabilities.shows(Gate.PRINT_ROSTER)
    // SH-98: Ctrl+P, like the print action in the bar (SH-261: the roster itself where it may be
    // printed, else the working-time record).
    ShortcutHandler(
        AppShortcut.PRINT,
        enabled = rosterPrintable || (state.roster != null && state.capabilities.shows(Gate.PRINT_WORKING_TIME))
    ) { if (rosterPrintable) showPrintRoster = true else showPrint = true }
    if (showPrintRoster && printRoster != null) {
        PrintRosterDialog(
            rosterId = printRoster.id,
            year = printRoster.year,
            month = printRoster.month,
            firstDayOfWeek = state.firstDayOfWeek,
            draft = rosterPublishState(printRoster.status, state.shiftsByDate.values.flatten()) != RosterPublishState.PUBLISHED,
            onDismiss = { showPrintRoster = false }
        )
    }
    if (showPrint && printRoster != null) {
        PrintWorkingTimeDialog(
            workplaceId = printRoster.workplaceId,
            year = printRoster.year,
            month = printRoster.month,
            people = printPeople,
            onDismiss = { showPrint = false }
        )
    }
    var showEmail by remember { mutableStateOf(false) }
    // SH-219: the start path's "Auto-assign" and "Send the PDF by e-mail" open them once the month is
    // read (and only where they are offered); once per visit.
    var initialActionDone by androidx.compose.runtime.saveable.rememberSaveable { mutableStateOf(initialAction == null) }
    val emailOffered = printRoster != null && state.capabilities.shows(Gate.EMAIL_ROSTER) && printRoster.status.let {
        it == com.evoapps.evoshift.domain.model.RosterStatus.PUBLISHED || it == com.evoapps.evoshift.domain.model.RosterStatus.LOCKED
    }
    val autoAssignOffered = state.roster != null && viewModel.autoAssignAvailable && state.canAutoAssign
    LaunchedEffect(initialAction, emailOffered, autoAssignOffered) {
        if (initialActionDone) return@LaunchedEffect
        when (initialAction) {
            RosterDetailAction.AUTO_ASSIGN -> if (autoAssignOffered) {
                initialActionDone = true
                if (state.autoAssign == null) viewModel.onAutoAssignClicked()
            }
            RosterDetailAction.EMAIL -> if (emailOffered) {
                initialActionDone = true
                showEmail = true
            }
            else -> initialActionDone = true
        }
    }
    if (showEmail && printRoster != null) {
        EmailRosterDialog(
            rosterId = printRoster.id,
            year = printRoster.year,
            month = printRoster.month,
            people = printPeople,
            onDismiss = { showEmail = false }
        )
    }

    // SH-158: the phone's modal day sheet covers the screen; while it is open, its own host shows
    // the snackbars ("Shift deleted." with Undo) and the screen's stays empty (one Undo at a time).
    val daySheetShown = showDayDetails != null && !LocalWindowWidthClass.current.showsDetailPane && !postureControlsShown
    Scaffold(
        snackbarHost = { if (!daySheetShown) SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            // SH-89: the shared bar: the workplace and "‹ Październik 2026 ›" (the app-wide month:
            // App.kt opens that month's roster). SH-229: the frequent actions as icons with tooltips
            // (copy, e-mail, auto-assign), the less used ones (help, print, import) in ⋮ on every
            // width, and Publish last, a filled gold button that says where the month stands.
            val printLabel = stringResource(Res.string.print_working_time)
            val printRosterLabel = stringResource(Res.string.print_roster)
            val publishLabel = stringResource(Res.string.roster_publish)
            val publishChangesLabel = stringResource(Res.string.roster_publish_changes)
            val publishedLabel = stringResource(Res.string.roster_published_state)
            val publishState = remember(state.roster?.status, state.shiftsByDate, state.removedShifts) {
                rosterPublishState(state.roster?.status, state.shiftsByDate.values.flatten(), state.removedShifts)
            }
            val emailLabel = stringResource(Res.string.email_roster)
            val autoAssignLabel = stringResource(Res.string.auto_assign)
            val copyLabel = stringResource(Res.string.copy_tool_title)
            val importLabel = stringResource(Res.string.roster_import_title)
            val newWindowLabel = stringResource(Res.string.open_in_new_window)
            val openInNewWindow = rememberOpenInNewWindow()
            EvoTopBar(
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    add(helpAction(HelpPage.ROSTER_BUILD).copy(inMenu = true))
                    // SH-261: the whole roster for the wall (owners and managers; in ⋮).
                    if (rosterPrintable) {
                        add(TopBarAction(printRosterLabel, Icons.Default.Print, { showPrintRoster = true }, inMenu = true))
                    }
                    if (state.roster != null && state.capabilities.shows(Gate.PRINT_WORKING_TIME)) {
                        add(TopBarAction(printLabel, Icons.Default.Print, { showPrint = true }, inMenu = true))
                    }
                    // SH-45: a published month goes to the team by e-mail (into ⋮ on a phone).
                    val sendable = state.roster?.status.let {
                        it == com.evoapps.evoshift.domain.model.RosterStatus.PUBLISHED || it == com.evoapps.evoshift.domain.model.RosterStatus.LOCKED
                    }
                    if (sendable && state.capabilities.shows(Gate.EMAIL_ROSTER)) {
                        add(TopBarAction(emailLabel, Icons.Default.Email, { showEmail = true }))
                    }
                    // SH-53: fill a draft month's unassigned shifts by the rules (into ⋮ on a phone).
                    if (viewModel.autoAssignAvailable && state.canAutoAssign && !postureControlsShown) {
                        add(TopBarAction(autoAssignLabel, Icons.Default.AutoFixHigh, { viewModel.onAutoAssignClicked() }, enabled = state.autoAssign == null))
                    }
                    // SH-215: the one "Copy shifts", an icon with a tooltip (SH-229), never in ⋮.
                    // With a day open it copies that day (the phone's sheet makes way for the tool), else last week.
                    if (viewModel.copyAvailable && state.canCopy) {
                        add(
                            TopBarAction(
                                copyLabel,
                                Icons.Default.ContentCopy,
                                {
                                    viewModel.onCopyClicked()
                                    if (daySheetShown) viewModel.onDateSelected(null)
                                },
                                enabled = state.copyTool == null,
                                collapsible = false,
                                testTag = CopyToolTags.OPEN
                            )
                        )
                    }
                    // SH-217: a month planned in a spreadsheet, imported (owners and managers, a month being built; in ⋮).
                    val importRoster = state.roster
                    if (onImport != null && importRoster != null && state.canCopy) {
                        add(TopBarAction(importLabel, Icons.Default.UploadFile, { onImport(importRoster.id) }, inMenu = true))
                    }
                    // SH-161 F3: this month in a window of its own (large windows and pointer devices; in ⋮).
                    val windowTarget = state.roster?.id?.let(WindowTarget::forRoster)
                    if (openInNewWindow != null && windowTarget != null) {
                        add(TopBarAction(newWindowLabel, Icons.AutoMirrored.Filled.OpenInNew, { openInNewWindow(windowTarget) }, inMenu = true))
                    }
                    if (state.capabilities.shows(Gate.PUBLISH_ROSTER) && !postureControlsShown) {
                        val publish = { viewModel.onPublishClicked() }
                        add(
                            when (publishState) {
                                RosterPublishState.DRAFT -> TopBarAction(publishLabel, Icons.Default.Publish, publish, enabled = !state.isPublishing, busy = state.isPublishing, primary = PrimaryStyle.FILLED)
                                RosterPublishState.CHANGES -> TopBarAction(
                                    publishChangesLabel, Icons.Default.Publish, publish,
                                    enabled = !state.isPublishing, busy = state.isPublishing, primary = PrimaryStyle.FILLED, compactLabel = publishLabel
                                )
                                // Published and unchanged: a quiet tick; pressing it publishes again.
                                RosterPublishState.PUBLISHED -> TopBarAction(publishedLabel, Icons.Default.TaskAlt, publish, enabled = !state.isPublishing, primary = PrimaryStyle.DONE)
                            }
                        )
                    }
                }
            )
        },
    ) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            val loadError = state.loadError
            if (loadError != null && state.roster == null) {
                // SH-168: the month could not be read: not an empty month, Try again.
                com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = viewModel::retry)
            } else if (state.isLoading && state.roster == null) {
                // SH-247: the month's shape (its days, or the grid on wide windows) until it is read.
                RosterPlaceholder()
            } else {

                val dates = if (state.roster != null) {
                    remember(state.roster) {
                        getDaysInMonth(
                            state.roster!!.year,
                            state.roster!!.month
                        )
                    }
                } else {
                    state.shiftsByDate.keys.sorted()
                }

                val rosterGrid: @Composable () -> Unit = {
                androidx.compose.runtime.CompositionLocalProvider(LocalUnpublishedHighlight provides if (showUnpublished) unpublishedIds else emptySet()) {
                Column(modifier = Modifier.fillMaxSize()) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(Color(0xFFFBF4E9))
                            .padding(vertical = 8.dp, horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(6.dp)
                    ) {
                        // SH-83: the counters wrap onto the next line on a narrow phone.
                        FlowRow(
                            horizontalArrangement = Arrangement.spacedBy(16.dp),
                            verticalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            // Hours somebody works: the same figure the publish summary shows.
                            // Open and unfilled shifts have their own counters next to it.
                            val totalHours = remember(state.shiftsByDate) { state.plannedHoursByUserId.values.sum() }
                            val (unfilled, open) = remember(state.shiftsByDate) {
                                val unassigned = state.shiftsByDate.values.flatten().filter { it.userId == null }
                                unassigned.count { !it.isOpen } to unassigned.count { it.isOpen }
                            }
                            val conflicts = state.conflictingShiftIds.size

                            StatBadge(
                                stringResource(Res.string.roster_total_hours),
                                "${totalHours.toInt()}h",
                                DeepNavy
                            )
                            StatBadge(
                                stringResource(Res.string.roster_unfilled),
                                "$unfilled",
                                if (unfilled > 0) Color(0xFFD32F2F) else DeepNavy
                            )
                            if (open > 0) {
                                StatBadge(stringResource(Res.string.roster_summary_open), "$open", DarkGold)
                            }
                            StatBadge(
                                stringResource(Res.string.roster_conflicts),
                                "$conflicts",
                                if (conflicts > 0) Color(0xFFD32F2F) else DeepNavy,
                                showIcon = conflicts > 0
                            )
                            // SH-112: soft warnings; the counter opens them per person.
                            val labourWarnings = state.labourReport.warnings.size
                            if (labourWarnings > 0) {
                                StatBadge(
                                    stringResource(Res.string.roster_labour_code),
                                    "$labourWarnings",
                                    LabourAmber,
                                    showIcon = true,
                                    modifier = Modifier.handCursor().clickable { showLabourCode = true }
                                )
                            }
                        }
                        // SH-115: the planned labour cost against the budget (money roles, budget on).
                        state.budgetStatus?.let { LabourBudgetHeader(it, state.currency, usedWhy = { state.budgetUsedExplained() }) }
                        // SH-147: people working without pay terms (money roles only; nothing otherwise).
                        state.roster?.id?.let { MissingPayBanner(MissingPayScope(it)) }
                    }

                    HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))

                    // SH-263: a published month changed since: the team sees the changes only after
                    // the next publish. A month never published keeps its "Publish" in the top bar.
                    val bannerRoster = state.roster
                    val compactList = LocalWindowWidthClass.current.isCompact
                    MotionVisibility(bannerRoster != null && unpublishedCount > 0) {
                        if (bannerRoster != null) UnpublishedChangesBanner(
                            year = bannerRoster.year,
                            month = bannerRoster.month,
                            count = unpublishedCount,
                            // SH-263: the removed shifts are listed in the banner (nothing to ring on the grid).
                            removed = unpublishedRemovals,
                            nameOf = { uid -> state.personNames[uid] ?: state.availableEmployees.find { it.uid == uid }?.displayName },
                            highlighted = showUnpublished,
                            publishing = state.isPublishing,
                            onPublish = { viewModel.onPublishClicked() },
                            onToggleHighlight = {
                                showUnpublished = !showUnpublished
                                // Shown: the first changed day (and on the grid its person) comes into view.
                                val first = state.shiftsByDate.values.flatten().filter { it.id in unpublishedIds }.minByOrNull { it.plannedTime.start }
                                val dayIndex = first?.let { dates.indexOf(LocalDate.parse(it.date)) } ?: -1
                                if (showUnpublished && dayIndex >= 0) pagerScope.launch {
                                    if (compactList || dayCellPx <= 0f) dayListState.animateScrollToItem(dayIndex)
                                    else {
                                        horizontalScrollState.animateScrollTo((dayIndex * dayCellPx).roundToInt())
                                        val row = state.gridPeople.indexOfFirst { it.uid == first?.userId }
                                        if (row >= 0) gridListState.animateScrollToItem(row)
                                    }
                                }
                            }
                        )
                    }

                    // SH-217: a draft nobody is on yet (empty, or only the skeleton's unassigned shifts)
                    // offers to import the month from a spreadsheet instead of entering it again.
                    val nobodyAssigned = remember(state.shiftsByDate) { state.shiftsByDate.values.all { day -> day.all { it.userId == null } } }
                    val importRoster = state.roster
                    MotionVisibility(onImport != null && importRoster != null && state.canCopy && importRoster.status == RosterStatus.DRAFT && nobodyAssigned) {
                        ImportFromSheetStrip { importRoster?.let { onImport?.invoke(it.id) } }
                    }

                    // SH-167: a draft with unfilled shifts offers auto-assign above the days (on a
                    // phone it would otherwise sit in ⋮); gone once all are filled. Copying lives in
                    // the top bar only (SH-215).
                    val unfilledCount = remember(state.shiftsByDate) { state.unfilledCount }
                    val stripAutoAssign = viewModel.autoAssignAvailable && state.canAutoAssign
                    MotionVisibility(state.roster?.status == RosterStatus.DRAFT && unfilledCount > 0 && stripAutoAssign) {
                        UnfilledStrip(
                            count = unfilledCount,
                            onAutoAssign = { viewModel.onAutoAssignClicked() },
                            autoAssignEnabled = state.autoAssign == null
                        )
                    }

                    if (LocalWindowWidthClass.current.isCompact) {
                        // Phones: a day list; the grid below needs a tablet or a desktop.
                        CompactRosterDayList(
                            dates = dates,
                            shiftsByDate = state.shiftsByDate,
                            dayWarnings = state.dayWarnings,
                            staffing = state.staffing?.byDate.orEmpty(),
                            engagementOf = { uid -> state.gridPeople.find { it.uid == uid }?.engagements?.get(state.roster?.workplaceId) },
                            leadRule = state.leadRule,
                            closedDays = state.closedDays,
                            onDayClick = { viewModel.onDateSelected(it) },
                            modifier = Modifier.fillMaxSize(),
                            state = dayListState,
                            interviewsByDate = interviewsByDate(state),
                            weather = state.weather,
                            specialDays = specials.days,
                            onDayLongClick = if (specials.canEdit) { day: LocalDate -> viewModel.specialDays.open(day) } else null
                        )
                    } else Row(Modifier.fillMaxSize()) {
                        // SH-98 / SH-105: on expanded and wider windows a pane stays beside the grid:
                        // the chosen day's shifts (instead of covering the grid with a sheet), else
                        // the month's overview (staffing warnings, the team's hours).
                        val widthClass = LocalWindowWidthClass.current
                        val large = widthClass.isLarge
                        val sidePane = widthClass.showsDetailPane && !postureControlsShown
                        val dockedDay = showDayDetails?.takeIf { sidePane }
                        // SH-54: the staffing chips need a line more in the day headers.
                        // SH-226: and the forecast another one.
                        val forecastLine = if (dates.any { it in state.weather }) 24.dp else 0.dp
                        // SH-227: and a day's event or special day one more, small.
                        val specialLine = if (dates.any { it in specials.days }) 18.dp else 0.dp
                        val headerHeight = (if (state.staffing?.days.isNullOrEmpty()) 86.dp else 100.dp) + forecastLine + specialLine
                        // Read-only once the plan ended (SH-65): the month to see, not to build.
                        val editable = state.capabilities.shows(Gate.ROSTER_EDITING)
                        // SH-267: the team, then the borrowed people with shifts this month.
                        val gridPeople = remember(state.availableEmployees, state.shiftsByDate, state.borrowCandidates) { state.gridPeople }
                        val people = remember(gridPeople) { gridPeople.map { it.uid } }
                        val startDate = remember(dates) { today.takeIf { it in dates } ?: dates.firstOrNull() }
                        // SH-169: Ctrl/Cmd+C and V on the keyboard's cell (or the selection), the zoom keys.
                        // SH-171: on day headers they copy the selected days (or the focused one) and
                        // paste them from the focused day (or from each selected day): the dialog first.
                        val onHeader = grid.headerCursor != null || grid.headerSelection.isNotEmpty()
                        ShortcutHandler(AppShortcut.COPY_CELL, enabled = editable && (grid.cursor != null || onHeader)) {
                            if (onHeader) viewModel.copyDays(grid.pickedDays) else grid.cursor?.let(viewModel::copyCell)
                        }
                        val pasteEnabled = if (onHeader) state.copiedDays != null && state.canCopy
                            else state.copiedShifts != null && (grid.cursor != null || grid.selection.isNotEmpty())
                        ShortcutHandler(AppShortcut.PASTE_CELL, enabled = editable && pasteEnabled) {
                            if (onHeader) {
                                viewModel.pasteDays(grid.pickedDays)
                                grid.clearHeaderSelection()
                            } else {
                                val targets = grid.selection.toList().ifEmpty { listOfNotNull(grid.cursor) }
                                viewModel.pasteCells(targets)
                                grid.clearSelection()
                                feedback.tick()
                            }
                        }
                        ShortcutHandler(AppShortcut.ZOOM_IN) { viewModel.zoomGrid(1) }
                        ShortcutHandler(AppShortcut.ZOOM_OUT) { viewModel.zoomGrid(-1) }
                        ShortcutHandler(AppShortcut.ZOOM_RESET) { viewModel.resetGridZoom() }
                        // A selection or a popover of a month that can no longer be changed goes.
                        if (!editable && (grid.selection.isNotEmpty() || grid.popover != null || grid.headerSelection.isNotEmpty())) SideEffect {
                            grid.clearSelection()
                            grid.clearHeaderSelection()
                            grid.popover = null
                        }
                        val gridActions = RosterGridActions(
                            editable = editable,
                            onOpen = { cell -> if (editable) grid.open(cell) },
                            onUnassign = { cell ->
                                val ids = state.shiftsByUserAndDate[cell.userId]?.get(cell.date).orEmpty().filter { it.userId != null }.map { it.id }
                                if (ids.isNotEmpty()) {
                                    viewModel.unassignShifts(ids)
                                    feedback.confirm()
                                }
                            },
                            onDrop = { shift, target ->
                                viewModel.moveShift(shift.id, target.userId, target.date)
                                feedback.tick()
                            },
                            onZoom = viewModel::zoomGrid,
                            onOpenDay = { viewModel.onDateSelected(it) },
                            startDate = startDate
                        )
                        val density = LocalDensity.current
                        // SH-98: wide windows: a wider name column, and the days share the width
                        // when the whole month fits (no sideways scrolling on a big screen).
                        val sidebarWidth = if (large) 180.dp else 140.dp
                        Box(Modifier.weight(1f).fillMaxHeight()) {
                        // SH-208: the scrollbars sit beside and under the grid, outside its pointer
                        // handling (a press on a bar never picks a cell or drags a chip); the
                        // sideways one spans the days only, not the names.
                        Row(Modifier.fillMaxSize()) {
                        Column(Modifier.weight(1f).fillMaxHeight()) {
                        BoxWithConstraints(Modifier.weight(1f).fillMaxWidth().rosterGridInput(grid, gridActions)) {
                        // SH-169: Ctrl+wheel and Ctrl +/- scale the days' width (kept on this device).
                        val cellWidth = (gridCellWidth(maxWidth - sidebarWidth - 16.dp, dates.size) * state.gridZoom).coerceAtLeast(GridCellZoomedMinWidth)
                        val cellPx = with(density) { cellWidth.toPx() }
                        val gridWidthPx = with(density) { maxWidth.toPx() }
                        SideEffect {
                            dayCellPx = cellPx
                            grid.geometry = GridGeometry(
                                people = people,
                                dates = dates,
                                sidebarPx = with(density) { sidebarWidth.toPx() },
                                headerPx = with(density) { headerHeight.toPx() + 1.dp.toPx() },
                                cellPx = cellPx,
                                rowPx = with(density) { GridRowHeight.toPx() },
                                cellPadPx = with(density) { 5.dp.toPx() },
                                widthPx = gridWidthPx,
                                list = gridListState,
                                row = horizontalScrollState,
                                shiftsOf = { cell -> state.shiftsByUserAndDate[cell.userId]?.get(cell.date).orEmpty() }
                            )
                        }
                        val ring = grid.cursor.takeIf { grid.showsRing && grid.headerCursor == null }
                        val headerRing = grid.headerCursor.takeIf { grid.showsRing }
                        val dropTarget = grid.drag?.target?.takeIf { it != grid.drag?.from }
                        LazyColumn(modifier = Modifier.fillMaxSize(), state = gridListState) {
                            stickyHeader {
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .background(Color(0xFFF7F2E9))
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .width(sidebarWidth)
                                            .height(headerHeight)
                                            .background(Color(0xFFFFF9E3))
                                    )
                                    Row(
                                        modifier = Modifier
                                            .weight(1f)
                                            .horizontalScroll(horizontalScrollState)
                                    ) {
                                        dates.forEach { date ->
                                            val dayShifts = state.shiftsByDate[date] ?: emptyList()
                                            // SH-171: right click: copy this day or the selected days (to
                                            // paste from another header, as Ctrl/Cmd+C), paste the copied
                                            // days from here (or from each selected day), the day's pane.
                                            ContextMenuArea(
                                                items = {
                                                    val onSelection = date in grid.headerSelection && grid.headerSelection.size > 1
                                                    val days = if (onSelection) grid.headerSelection else setOf(date)
                                                    dayHeaderMenu(
                                                        labels = dayHeaderMenuLabels,
                                                        canCopy = editable && viewModel.copyAvailable && state.canCopy,
                                                        onSelection = onSelection,
                                                        hasShifts = days.any { !state.shiftsByDate[it].isNullOrEmpty() },
                                                        canPaste = state.copiedDays != null,
                                                        onCopy = { viewModel.copyDays(days) },
                                                        onPaste = {
                                                            viewModel.pasteDays(days)
                                                            grid.clearHeaderSelection()
                                                        },
                                                        onShowDay = { viewModel.onDateSelected(date) },
                                                        // SH-227: the day's events (one day, owners and managers).
                                                        events = if (specials.canEdit && !onSelection) specials.eventsOn(date) else emptyList(),
                                                        onAddEvent = { viewModel.specialDays.open(date) }.takeIf { specials.canEdit && !onSelection },
                                                        onEditEvent = { id -> viewModel.specialDays.edit(id, date) }
                                                    )
                                                },
                                                modifier = Modifier.testTag(RosterGridTags.header(date))
                                            ) {
                                                val headerSelected = date in grid.headerSelection
                                                Box(
                                                    modifier = Modifier
                                                        .height(headerHeight)
                                                        .handCursor()
                                                        // SH-227: holding a day adds an event (or opens the day's events).
                                                        .combinedClickable(
                                                            onLongClick = { viewModel.specialDays.open(date) }.takeIf { specials.canEdit },
                                                            onLongClickLabel = addEventLabel.takeIf { specials.canEdit }
                                                        ) { viewModel.onDateSelected(date) }
                                                        .semantics { selected = headerSelected }
                                                ) {
                                                    DateHeaderItem(
                                                        date, dayShifts, today, state.closedDays[date], state.dayWarnings[date], state.staffing?.byDate?.get(date),
                                                        width = cellWidth,
                                                        selected = date == dockedDay,
                                                        weather = state.weather[date],
                                                        specials = specials.days[date]
                                                    )
                                                    DayHeaderMarks(
                                                        focusRing = date == headerRing,
                                                        selected = date in grid.headerSelection,
                                                        copied = state.copiedDays?.contains(date) == true
                                                    )
                                                }
                                            }
                                        }
                                        Spacer(Modifier.width(16.dp))
                                    }
                                }
                                HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))
                            }

                            items(gridPeople, key = { it.uid }) { employee ->
                                // From the observed state, so the sidebar updates with the shifts.
                                val monthlyHours = hoursByUser[employee.uid] ?: 0.0
                                val theirShifts = state.shiftsByUserAndDate[employee.uid].orEmpty()
                                val theirDays = state.availabilityByUserId[employee.uid]?.days
                                    ?: state.borrowCandidates.firstOrNull { it.userId == employee.uid }?.days
                                val theirBusy = state.busyElsewhereByUserAndDate[employee.uid]
                                val workplaceId = state.roster?.workplaceId ?: ""
                                val engagement = employee.engagements[workplaceId]
                                // No role: show nothing rather than a made-up "Employee".
                                val role = state.guestFromName(employee.uid)?.takeIf { state.availableEmployees.none { it.uid == employee.uid } }
                                    ?.let { stringResource(Res.string.roster_picker_guest_from, it) }
                                    ?: engagement?.role?.takeIf { it.isNotBlank() }.orEmpty()

                                Row(
                                    modifier = Modifier
                                        .animateItemIfMotion(this)
                                        .fillMaxWidth()
                                        .height(GridRowHeight)
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .width(sidebarWidth)
                                            .fillMaxHeight()
                                            .background(Color(0xFFFFF9E3))
                                    ) {
                                        EmployeeSidebarItem(
                                            employee, role, monthlyHours, state.targetHoursByUserId[employee.uid],
                                            engagement = engagement,
                                            leadRule = state.leadRule,
                                            readiness = state.readinessByUserId[employee.uid],
                                            labourWarnings = state.issuesByUserId[employee.uid].orEmpty().count { it is RosterIssue.Labour },
                                            issues = state.issuesByUserId[employee.uid].orEmpty(),
                                            onOpenIssue = { issue -> state.shiftOf(issue, employee.uid)?.let(viewModel::onShiftClicked) }
                                        )
                                    }

                                    Row(
                                        modifier = Modifier
                                            .weight(1f)
                                            .fillMaxHeight()
                                            .horizontalScroll(horizontalScrollState)
                                    ) {
                                        dates.forEach { date ->
                                            val cellShifts = theirShifts[date].orEmpty()
                                            val cell = GridCell(employee.uid, date)
                                            // SH-169: a click (or Enter) opens the cell's popover beside it.
                                            val openAssign = { if (editable) grid.open(cell) }
                                            val selected = cell in grid.selection
                                            // SH-98: right click: the cell's actions (what a tap and the
                                            // day's sheet lead to), straight from the grid.
                                            ContextMenuArea(
                                                items = {
                                                    shiftCellMenu(
                                                        labels = cellMenuLabels,
                                                        shifts = cellShifts,
                                                        editable = editable,
                                                        onAssign = openAssign,
                                                        onEdit = viewModel::onShiftClicked,
                                                        onUnassign = viewModel::unassignShift,
                                                        onShowDay = { viewModel.onDateSelected(date) }
                                                    )
                                                },
                                                modifier = Modifier.testTag(RosterGridTags.cell(employee.uid, date))
                                            ) {
                                                // Each cell gets only its own data, so a change elsewhere
                                                // in the month does not recompose it.
                                                // SH-158: and only the month's marks on its own shifts,
                                                // so a warning elsewhere does not recompose it either.
                                                ShiftCell(
                                                    shifts = cellShifts,
                                                    date = date,
                                                    today = today,
                                                    pref = theirDays?.get(date.day),
                                                    availabilitySlots = state.availabilitySlots,
                                                    // SH-133: the marks follow every grid check (RosterIssues).
                                                    conflictingShiftIds = state.issues.conflictShiftIds.onlyOf(cellShifts),
                                                    labourWarningShiftIds = state.issues.labourShiftIds.onlyOf(cellShifts),
                                                    busyElsewhere = theirBusy?.get(date).orEmpty(),
                                                    elsewhereIssues = state.elsewhereIssues.onlyOf(cellShifts),
                                                    closed = date in state.closedDays,
                                                    width = cellWidth,
                                                    issuesByShiftId = state.issues.byShiftId.onlyOf(cellShifts),
                                                    onOpenShift = viewModel::onShiftClicked,
                                                    selected = selected,
                                                    // SH-210: the person's job interviews that day.
                                                    interviews = state.interviewsByUserAndDate[employee.uid]?.get(date).orEmpty(),
                                                    // SH-223: remote work or a work event that day.
                                                    workMarks = state.workMarksByUserAndDate[employee.uid]?.get(date).orEmpty(),
                                                    onClick = openAssign
                                                )
                                                GridCellMarks(focusRing = cell == ring, selected = selected, dropTarget = cell == dropTarget)
                                                if (grid.popover == cell) {
                                                    CellPopover(
                                                        title = stringResource(Res.string.roster_assign_shift_to, employee.displayName),
                                                        subtitle = dayAndDate(date),
                                                        onDismiss = grid::closePopover
                                                    ) {
                                                        CellAssignContent(state, viewModel, employee, date, onDone = {
                                                            feedback.tick()
                                                            grid.closePopover()
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                        Spacer(Modifier.width(16.dp))
                                    }
                                }
                                HorizontalDivider(color = GridLine)
                            }

                            // SH-226: the forecast's credit, under the grid whose headers show it.
                            if (forecastLine > 0.dp) {
                                item(key = "weather-attribution") {
                                    CompositionLocalProvider(LocalContentColor provides DeepNavy.copy(alpha = 0.75f)) {
                                        WeatherAttribution(
                                            com.evoapps.evoshift.domain.model.DayWeather.sourcesOf(dates.map { state.weather[it] }),
                                            Modifier.padding(horizontal = 16.dp, vertical = 8.dp)
                                        )
                                    }
                                }
                            }
                            item { Spacer(Modifier.height(80.dp)) }
                        }
                        grid.drag?.let { DragGhost(it, cellPx) }
                        }
                        // SH-169 / SH-208: scrollbars for the mouse (the desktop app and the web).
                        RowHorizontalScrollbar(horizontalScrollState, Modifier.padding(start = sidebarWidth).fillMaxWidth())
                        }
                        ListVerticalScrollbar(gridListState, Modifier.fillMaxHeight())
                        }
                        // Over the grid, outside its pointer handling (a click on the bar is the bar's).
                        if (editable && grid.selection.isNotEmpty()) {
                            SelectionBar(
                                count = grid.selection.size,
                                templates = state.shiftTemplates,
                                onApply = { template ->
                                    viewModel.applyTemplateToCells(grid.selection.toList(), template)
                                    grid.clearSelection()
                                    feedback.tick()
                                },
                                onClear = grid::clearSelection
                            )
                        }
                        }
                        val paneWidth = if (large) DayPaneWidth else DayPaneWidthExpanded
                        if (dockedDay != null) {
                            DetailPaneBack(onClose = { viewModel.onDateSelected(null) })
                            DayDetailsPane(
                                title = dayAndDate(dockedDay),
                                onClose = { viewModel.onDateSelected(null) },
                                modifier = Modifier.width(paneWidth).fillMaxHeight()
                            ) {
                                DayDetailsSheetContent(
                                    shifts = state.shiftsByDate[dockedDay].orEmpty(),
                                    warning = state.dayWarnings[dockedDay],
                                    closure = state.closedDays[dockedDay],
                                    staffing = state.staffing?.byDate?.get(dockedDay),
                                    currency = state.currency,
                                    labourWarnings = state.labourReport.byShiftId,
                                    issues = state.issues.byShiftId,
                                    onShiftClick = { shift -> viewModel.onShiftClicked(shift) },
                                    editing = dayEditing(dockedDay),
                                    costOf = state.budget?.estimate?.let { e -> e::pricedCostOf },
                                    names = state.personNames,
                                    missingPay = state.roster?.id?.let { MissingPayScope(it, dockedDay.toString()) },
                                    assigning = dayAssigning(),
                                    answers = state.dayAnswers(dockedDay),
                                    specials = specials.days[dockedDay]
                                )
                            }
                        } else if (sidePane) {
                            RosterOverviewPane(
                                state = state,
                                onDayClick = { viewModel.onDateSelected(it) },
                                // A very wide window keeps the whole month beside it at 64 dp a day.
                                modifier = Modifier.width(if (widthClass == WindowWidthClass.EXTRA_LARGE) OverviewPaneWidthXl else paneWidth).fillMaxHeight()
                            )
                        }
                    }
                }
                }
                }

                // The first day in view, and a jump to a day: the grid's columns or the list's rows.
                val compact = LocalWindowWidthClass.current.isCompact
                fun firstDay(): Int = if (compact || dayCellPx <= 0f) dayListState.firstVisibleItemIndex
                    else (horizontalScrollState.value / dayCellPx).roundToInt()
                fun showDay(index: Int) {
                    pagerScope.launch {
                        if (compact || dayCellPx <= 0f) dayListState.animateScrollToItem(index)
                        else horizontalScrollState.animateScrollTo((index * dayCellPx).roundToInt())
                    }
                }
                val publishLabel = stringResource(Res.string.roster_publish)
                val autoAssignLabel = stringResource(Res.string.auto_assign)
                // SH-102: on a foldable the month above the hinge (left when flat and nearly square),
                // the pager, publish and the chosen day's shifts below it.
                PostureAwareScaffold(
                    controls = {
                        DisposableEffect(Unit) {
                            postureControlsShown = true
                            onDispose { postureControlsShown = false }
                        }
                        val day = showDayDetails
                        RosterPostureControls(
                            onPreviousWeek = { showDay(weekStepTarget(firstDay(), -1, dates.size)) },
                            onThisWeek = { showDay(dates.indexOf(today).coerceAtLeast(0)) },
                            onNextWeek = { showDay(weekStepTarget(firstDay(), 1, dates.size)) },
                            onPublish = { viewModel.onPublishClicked() }.takeIf { state.capabilities.shows(Gate.PUBLISH_ROSTER) },
                            publishEnabled = !state.isPublishing,
                            publishLabel = publishLabel,
                            onAutoAssign = { viewModel.onAutoAssignClicked() }.takeIf { viewModel.autoAssignAvailable && state.canAutoAssign },
                            autoAssignEnabled = state.autoAssign == null,
                            autoAssignLabel = autoAssignLabel,
                            day = day?.let { date ->
                                {
                                    DayDetailsPane(
                                        title = dayAndDate(date),
                                        onClose = { viewModel.onDateSelected(null) },
                                        modifier = Modifier.fillMaxSize()
                                    ) {
                                        DayDetailsSheetContent(
                                            shifts = state.shiftsByDate[date].orEmpty(),
                                            warning = state.dayWarnings[date],
                                            closure = state.closedDays[date],
                                            staffing = state.staffing?.byDate?.get(date),
                                            currency = state.currency,
                                            labourWarnings = state.labourReport.byShiftId,
                                            issues = state.issues.byShiftId,
                                            onShiftClick = { shift -> viewModel.onShiftClicked(shift) },
                                            editing = dayEditing(date),
                                            costOf = state.budget?.estimate?.let { e -> e::pricedCostOf },
                                            names = state.personNames,
                                            missingPay = state.roster?.id?.let { MissingPayScope(it, date.toString()) },
                                            assigning = dayAssigning(),
                                            answers = state.dayAnswers(date),
                                            specials = specials.days[date]
                                        )
                                    }
                                }
                            }
                        )
                    },
                    normal = rosterGrid,
                    content = { rosterGrid() }
                )
            }
        }
    }

    // Expanded and wider windows dock the day beside the grid (above, SH-105); narrower ones get
    // the sheet, a foldable's controls pane holds it (SH-102).
    if (daySheetShown) {
        val date = showDayDetails!!
        val shiftsForDay = state.shiftsByDate[date] ?: emptyList()
        EvoBottomSheet(
            onDismiss = { viewModel.onDateSelected(null) },
            title = dayAndDate(date),
            icon = Icons.Default.CalendarToday,
            sheetState = sheetState,
            snackbarHostState = snackbarHostState,
            // SH-222: the sheet covers the top bar's "Kopiuj zmiany" on a phone, so its ⋮ copies
            // this day (where copying is allowed: the top bar's conditions); no visible button.
            // SH-227: and "Dodaj wydarzenie…" for owners and managers.
            headerActions = if ((viewModel.copyAvailable && state.canCopy) || specials.canEdit) {
                {
                    DaySheetMenu(
                        copyEnabled = state.copyTool == null,
                        onCopyDay = {
                            viewModel.onCopyClicked()
                            viewModel.onDateSelected(null)
                        }.takeIf { viewModel.copyAvailable && state.canCopy },
                        onAddEvent = {
                            viewModel.onDateSelected(null)
                            viewModel.specialDays.open(date)
                        }.takeIf { specials.canEdit }
                    )
                }
            } else null
        ) {
            DayDetailsSheetContent(
                shifts = shiftsForDay,
                warning = state.dayWarnings[date],
                closure = state.closedDays[date],
                staffing = state.staffing?.byDate?.get(date),
                currency = state.currency,
                labourWarnings = state.labourReport.byShiftId,
                issues = state.issues.byShiftId,
                onShiftClick = { shift ->
                    viewModel.onShiftClicked(shift)
                    viewModel.onDateSelected(null)
                },
                editing = dayEditing(date),
                costOf = state.budget?.estimate?.let { e -> e::pricedCostOf },
                names = state.personNames,
                missingPay = state.roster?.id?.let { MissingPayScope(it, date.toString()) },
                assigning = dayAssigning(),
                answers = state.dayAnswers(date),
                specials = specials.days[date]
            )
        }
    }

    // SH-227: the event dialog (from a day's menu, or holding a day).
    specials.dialog?.let { dialog ->
        LocalEventDialog(
            state = dialog,
            onSave = { name, from, to, yearly, alsoIn -> viewModel.specialDays.submit(name, from, to, yearly, alsoIn) },
            onEdit = { id -> viewModel.specialDays.edit(id, dialog.date) },
            onDelete = { viewModel.specialDays.deleteEditing() },
            onDismiss = { viewModel.specialDays.dismiss() }
        )
    }

    // SH-236: the shift whose "Who worked…" or "Split shift…" dialog is open (the edit dialog makes way).
    var actualWorkShiftId by remember { mutableStateOf<String?>(null) }
    var splitShiftId by remember { mutableStateOf<String?>(null) }
    val shiftById = { id: String? -> id?.let { wanted -> state.shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == wanted } } } }
    shiftById(actualWorkShiftId)?.let { shift ->
        ActualWorkDialog(
            shift = shift,
            staff = state.availableEmployees,
            nameOf = viewModel::nameOf,
            onDismiss = { actualWorkShiftId = null },
            onSave = { worker, actual, absence ->
                actualWorkShiftId = null
                viewModel.recordActualWork(shift.id, worker, actual, absence)
                feedback.confirm()
            }
        )
    }
    shiftById(splitShiftId)?.let { shift ->
        SplitShiftDialog(
            shift = shift,
            staff = state.availableEmployees,
            nameOf = viewModel::nameOf,
            today = viewModel.todayIso,
            onDismiss = { splitShiftId = null },
            onSplit = { r ->
                splitShiftId = null
                viewModel.splitShift(shift.id, r.handoverAt, r.replacementId, r.reason, r.sickness, r.recordSickLeave)
                feedback.confirm()
            }
        )
    }

    if (state.editingShift != null) {
        val editedDay = LocalDate.parse(state.editingShift!!.date).day
        ShiftEditDialog(
            shift = state.editingShift!!,
            employees = state.availableEmployees,
            // The same availability the wide grid shows (SH-75): phones assign people only here.
            availabilityFor = { uid -> state.availabilityByUserId[uid]?.days?.get(editedDay) },
            availabilitySlots = state.availabilitySlots,
            availableRoles = state.availableRoles,
            onDismiss = { viewModel.onDismissEdit() },
            onUpdate = { id, userId, role, skills, planned, actual, open, breaks ->
                viewModel.updateShift(id, userId, role, skills, planned, actual, open, breaks)
            },
            // SH-115: the change's cost and what the budget has left, live (null: no budget).
            budgetEffect = state.budgetStatus?.let { _ ->
                { userId: String?, hours: Double -> state.budgetEffect(LocalDate.parse(state.editingShift!!.date), state.editingShift!!.id, userId, hours) }
            },
            currency = state.currency,
            // The dialog makes way for the confirmation (one dialog at a time).
            // SH-167: deleted at once (with Undo), or the dialog makes way for the confirmation.
            onDelete = state.editingShift!!.let { editing ->
                { if (viewModel.requestDelete(editing)) feedback.confirm() }
            }.takeIf { state.canEditShifts && viewModel.deleteAvailable },
            // SH-167: "Actual time" and breaks only once the shift has started (or has clock times).
            started = state.editingShift!!.hasStarted(),
            // Each person's cost for the shift, to money roles (budget on or off).
            shiftCost = state.budget?.let { _ ->
                { userId: String?, hours: Double -> state.shiftCostExplained(state.editingShift?.id, userId, hours) }
            },
            // SH-236: who actually worked (days up to today) and splitting the shift (also ahead).
            nameOf = viewModel::nameOf,
            onActualWork = state.editingShift!!.let { editing ->
                {
                    viewModel.onDismissEdit()
                    actualWorkShiftId = editing.id
                }
            }.takeIf { viewModel.mayRecordActualWork(state.editingShift!!) },
            onSplit = state.editingShift!!.let { editing ->
                {
                    viewModel.onDismissEdit()
                    splitShiftId = editing.id
                }
            }.takeIf { viewModel.maySplit(state.editingShift!!) },
            onUndoSplit = state.editingShift!!.let { editing -> { viewModel.undoSplit(editing.id) } }
                .takeIf { viewModel.maySplit(state.editingShift!!) }
        )
    }

    // SH-167: only an assigned shift of a published month asks before it goes.
    state.pendingDelete?.let { shift ->
        DeleteShiftConfirmation(
            shift = shift,
            onConfirm = {
                viewModel.confirmDelete()
                feedback.confirm()
            },
            onDismiss = { viewModel.cancelDelete() }
        )
    }
}

/**
 * SH-222: the phone day sheet's ⋮: "Kopiuj ten dzień…" opens the copy tool (SH-205) with the day
 * as the source, straight to where to; the sheet closes for it.
 */
@Composable
private fun DaySheetMenu(copyEnabled: Boolean, onCopyDay: (() -> Unit)?, onAddEvent: (() -> Unit)? = null) {
    var open by remember { mutableStateOf(false) }
    Box {
        IconButtonWithTooltip(onClick = { open = true }, modifier = Modifier.handCursor().testTag(CopyToolTags.DAY_SHEET_MENU), tooltip = stringResource(Res.string.top_bar_more)) {
            Icon(Icons.Default.MoreVert, stringResource(Res.string.top_bar_more), tint = LightGold)
        }
        DropdownMenu(expanded = open, onDismissRequest = { open = false }) {
            if (onCopyDay != null) {
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.roster_day_copy_this)) },
                    leadingIcon = { Icon(Icons.Default.ContentCopy, contentDescription = null) },
                    enabled = copyEnabled,
                    onClick = {
                        open = false
                        onCopyDay()
                    },
                    modifier = Modifier.handCursor().testTag(CopyToolTags.DAY_SHEET_COPY)
                )
            }
            // SH-227: an event on this day (the dialog lists the day's events to open one).
            if (onAddEvent != null) {
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.local_event_add)) },
                    leadingIcon = { Icon(Icons.Default.Event, contentDescription = null) },
                    onClick = {
                        open = false
                        onAddEvent()
                    },
                    modifier = Modifier.handCursor().testTag(DAY_SHEET_ADD_EVENT_TAG)
                )
            }
        }
    }
}

/**
 * SH-169: a person's day in the grid's cell popover: their shifts that day (unassign, with Undo),
 * the day's unassigned shifts they fit (one click assigns, with the soft validation), the shift
 * templates and custom times. [onDone] after a choice (the popover closes, the keyboard goes on).
 */
@Composable
private fun CellAssignContent(state: RosterDetailUiState, viewModel: RosterDetailViewModel, employee: User, date: LocalDate, onDone: () -> Unit) {
    val allShiftsForDay = state.shiftsByDate[date].orEmpty()
    val assignedToUser = allShiftsForDay.filter { it.userId == employee.uid }
    val engagement = employee.engagements[state.roster?.workplaceId.orEmpty()]
    val employeeSkills = engagement?.skills.orEmpty()
    // The day's unassigned shifts the person may work: any position or theirs, every skill it needs.
    val skeletonShifts = allShiftsForDay.filter { shift ->
        shift.userId == null &&
            (shift.requiredRole.isNullOrBlank() || shift.requiredRole == engagement?.role) &&
            (shift.requiredSkills.isEmpty() || shift.requiredSkills.all { it in employeeSkills })
    }
    AssignShiftSheetContent(
        date = date,
        preference = state.availabilityByUserId[employee.uid]?.days?.get(date.day),
        availabilitySlots = state.availabilitySlots,
        availableRoles = state.availableRoles,
        assignedShifts = assignedToUser,
        skeletonShifts = skeletonShifts,
        templates = state.shiftTemplates,
        // SH-115: what each option costs and leaves of the budget (null: no budget).
        budgetEffect = state.budgetStatus?.let { _ ->
            { shiftId: String?, hours: Double -> state.budgetEffect(date, shiftId, employee.uid, hours) }
        },
        currency = state.currency,
        // What each option costs for this person, to money roles (budget on or off).
        shiftCost = state.budget?.let { _ ->
            { shiftId: String?, hours: Double -> state.shiftCostExplained(shiftId, employee.uid, hours) }
        },
        onAddShift = { template ->
            viewModel.createShiftFromTemplate(date, template, employee.uid)
            onDone()
        },
        onAssignSkeletonShift = { shiftId ->
            viewModel.assignShift(shiftId, employee.uid)
            onDone()
        },
        onUnassignShift = { shiftId ->
            viewModel.unassignShifts(listOf(shiftId))
            onDone()
        },
        // The same editor as a tap on the shift in the day panel.
        onEditShift = { shift ->
            onDone()
            viewModel.onShiftClicked(shift)
        },
        onCreateCustom = { start, end, role ->
            // A one-off shift: the same path as a template, without saving a template.
            viewModel.createShiftFromTemplate(
                date,
                ShiftTemplate(id = "custom", name = role.orEmpty(), startTime = start, endTime = end, role = role, skills = emptyList()),
                employee.uid
            )
            onDone()
        },
        busyElsewhere = state.busyElsewhereByUserAndDate[employee.uid]?.get(date).orEmpty()
    )
}

/** One figure of the publish summary: the value large, its label under it. */
@Composable
private fun PublishStat(value: String, label: String, color: Color) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Text(value, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold, color = color)
        Text(label, style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.6f))
    }
}

@Composable
fun StatBadge(label: String, value: String, color: Color, showIcon: Boolean = false, modifier: Modifier = Modifier) {
    Row(modifier, verticalAlignment = Alignment.CenterVertically) {
        Text(
            text = "$label: ",
            style = MaterialTheme.typography.bodySmall,
            color = DeepNavy.copy(alpha = 0.7f),
            // A counter wraps as a whole (FlowRow), never inside its words (SH-83).
            maxLines = 1,
            softWrap = false
        )
        // SH-158: the counter's figure rolls to its new value as shifts change.
        AnimatedAmountText(
            text = value,
            style = MaterialTheme.typography.bodySmall,
            fontWeight = FontWeight.Bold,
            color = color,
            maxLines = 1,
            softWrap = false
        )
        if (showIcon) {
            Icon(
                Icons.Default.Warning,
                null,
                tint = color,
                modifier = Modifier.size(14.dp).padding(start = 2.dp)
            )
        }
    }
}

// --- Grid look: navy metal shift cards on a calm cream grid, as in the rest of the app ---

private val GridLine: Color get() = DeepNavy.copy(alpha = 0.07f)
private val WeekendTint = Color(0xFFF6EEDD)
private val TodayTint = Color(0xFFFFF4D6)
/** SH-55: a day the Sunday policy closes (non-trading Sunday, public holiday). */
private val ClosedTint = Color(0xFFE9E6E1)
private val ClosedGrey = Color(0xFF6B6760)
private val AvailableGreen = Color(0xFF2E7D32)
private val UnavailableRed = Color(0xFFC62828)
internal val ConflictRed = Color(0xFFD32F2F)
/** SH-112: a labour-code warning (soft; red stays for conflicts). */
internal val LabourAmber = Color(0xFFE67E00)

private fun LocalDate.isWeekend() = dayOfWeek == DayOfWeek.SATURDAY || dayOfWeek == DayOfWeek.SUNDAY

private fun today(): LocalDate = AppClock.now().toLocalDateTime(TimeZone.currentSystemDefault()).date

/** SH-167: the shift's planned start has passed (AppClock, the device's zone). */
internal fun Shift.hasStarted(now: kotlin.time.Instant = AppClock.now()): Boolean =
    plannedTime.start.isNotEmpty() && now.toLocalDateTime(TimeZone.currentSystemDefault()).toString() >= plannedTime.start

/** The column background of a day: today stands out, closed days are grey, weekends are warmer. */
private fun columnTint(date: LocalDate, today: LocalDate, closed: Boolean = false): Color = when {
    date == today -> TodayTint
    closed -> ClosedTint
    date.isWeekend() -> WeekendTint
    else -> Color.Transparent
}

/** Whole hours stay whole ("96"), halves keep their decimal ("7.5"). */
private fun formatHours(hours: Double): String =
    if (hours % 1.0 == 0.0) hours.toInt().toString() else ((hours * 10).toInt() / 10.0).toString()

private fun initials(name: String): String =
    name.split(" ").filter { it.isNotBlank() }.take(2).joinToString("") { it.first().uppercase() }.ifEmpty { "?" }

@Composable
fun EmployeeSidebarItem(
    employee: User,
    role: String,
    monthlyHours: Double,
    targetHours: Double? = null,
    /** SH-47: the star (shift lead) and the "needs supervision" mark. */
    engagement: Engagement? = null,
    /** SH-104: who leads shifts here, for the star. */
    leadRule: ShiftLeadRule = ShiftLeadRule(),
    /** SH-47: an expired medical exam or OHS training shows a red mark by the name. */
    readiness: StaffReadiness? = null,
    /** SH-112: how many labour-code warnings the person has this month (an amber mark by the name). */
    labourWarnings: Int = 0,
    /**
     * SH-133: all of the person's warnings this month: hovering the person shows them, a click or
     * tap pins them, grouped and dated, each opening its shift ([onOpenIssue]).
     */
    issues: List<RosterIssue> = emptyList(),
    onOpenIssue: ((RosterIssue) -> Unit)? = null
) {
    val explain = rememberExplainState()
    val leads = engagement?.let { leadRule.leads(it, employee.uid) } ?: false
    val supervised = engagement?.let { leadRule.needsSupervision(it, employee.uid) } ?: false
    val marks = PersonMarks(leads = leads, supervised = supervised, checksExpired = readiness?.anyExpired == true)
    val explained = issues.isNotEmpty() || leads || supervised || marks.checksExpired
    val conflicts = issues.any { it.isConflict }
    val marksDescription = stringResource(Res.string.issue_person_marks, employee.displayName, issues.size)
    Box(
        Modifier.fillMaxSize()
            .then(
                if (explained) Modifier.explainOnHover(explain).explainOnClick(explain, marksDescription).testTag(RosterIssueTags.person(employee.uid))
                else Modifier
            )
    ) {
    // Planned (not clocked) hours against the contract where it says how many; otherwise the bar
    // is a feel for the load against a full-time month (~160 h).
    val load = animatedFraction((monthlyHours / (targetHours ?: 160.0)).toFloat().coerceIn(0f, 1f))
    val over = targetHours != null && monthlyHours > targetHours + 0.01
    Row(
        modifier = Modifier.fillMaxSize().padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(32.dp)
                .clip(CircleShape)
                .background(DarkMetallicBackgroundBrush)
                .border(1.dp, DarkGold.copy(alpha = 0.6f), CircleShape),
            contentAlignment = Alignment.Center
        ) {
            Text(initials(employee.displayName), color = LightGold, fontSize = 12.sp, fontWeight = FontWeight.Bold)
        }
        Spacer(Modifier.width(8.dp))
        Column(Modifier.weight(1f)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    text = employee.displayName.split(" ").firstOrNull() ?: "",
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f, fill = false)
                )
                StaffBadges(engagement, leadRule, employee.uid, size = 12.dp, modifier = Modifier.padding(start = 3.dp))
                if (readiness?.anyExpired == true) {
                    Icon(
                        Icons.Default.HealthAndSafety,
                        contentDescription = stringResource(Res.string.staff_status_expired),
                        tint = ConflictRed,
                        modifier = Modifier.padding(start = 2.dp).size(12.dp)
                    )
                }
                if (conflicts) {
                    Icon(Icons.Default.Warning, contentDescription = null, tint = ConflictRed, modifier = Modifier.padding(start = 2.dp).size(12.dp))
                }
                if (labourWarnings > 0) {
                    Icon(
                        Icons.Default.Gavel,
                        contentDescription = stringResource(Res.string.roster_shift_labour_warning),
                        tint = LabourAmber,
                        modifier = Modifier.padding(start = 2.dp).size(12.dp)
                    )
                }
            }
            if (role.isNotBlank()) {
                Text(
                    text = role,
                    style = MaterialTheme.typography.labelSmall,
                    color = DeepNavy.copy(alpha = 0.6f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            Spacer(Modifier.height(4.dp))
            Box(
                Modifier.fillMaxWidth().height(4.dp).clip(RoundedCornerShape(2.dp)).background(DeepNavy.copy(alpha = 0.08f))
            ) {
                Box(
                    Modifier.fillMaxWidth(load).fillMaxHeight().clip(RoundedCornerShape(2.dp))
                        .background(if (over) SolidColor(ConflictRed) else GoldMetallicBrush)
                )
            }
            // SH-158: the person's month rolls to its new hours as shifts are assigned.
            AnimatedAmountText(
                text = if (targetHours != null) {
                    stringResource(Res.string.roster_planned_hours_of, formatHours(monthlyHours), formatHours(targetHours))
                } else {
                    stringResource(Res.string.roster_planned_hours, formatHours(monthlyHours))
                },
                style = LocalTextStyle.current.copy(fontSize = 10.sp),
                color = if (over) ConflictRed else DeepNavy.copy(alpha = 0.55f),
                fontWeight = if (over) FontWeight.Bold else FontWeight.Normal,
                maxLines = 1
            )
        }
    }
    if (explained) {
        ExplainPopups(
            explain,
            tooltip = { PersonIssuesCard(employee.displayName, issues, marks) },
            popover = { close ->
                PersonIssuesCard(employee.displayName, issues, marks, onOpenShift = onOpenIssue?.let { open -> { issue -> close(); open(issue) } }, onClose = close)
            }
        )
    }
    }
}

@Composable
fun DateHeaderItem(
    date: LocalDate,
    shifts: List<Shift>,
    today: LocalDate,
    closure: DayClosure? = null,
    warning: DayStaffAlert? = null,
    /** SH-54: the day's staffing hint, for those who may see money. */
    staffing: DayStaffingHint? = null,
    /** SH-98: the column's width (wider on a big window). */
    width: Dp = GridCellMinWidth,
    /** SH-98: the day shown in the docked day pane. */
    selected: Boolean = false,
    /** SH-226: the day's forecast (today and the coming days only). */
    weather: DayWeather? = null,
    /** SH-227: the day's events and special days (one small marker). */
    specials: DaySpecials? = null
) {
    val unfilledCount = shifts.count { it.userId == null && !it.isOpen }
    val openCount = shifts.count { it.userId == null && it.isOpen }
    val isToday = date == today
    val closureText = closure?.let { closureLabel(it) }.orEmpty()

    Column(
        modifier = Modifier
            .width(width)
            .fillMaxHeight()
            .background(columnTint(date, today, closure != null))
            .then(if (selected) Modifier.border(2.dp, DarkGold) else Modifier)
            .padding(vertical = 6.dp)
            // SH-55: the whole reason for screen readers and tests, "Closed" on screen.
            .then(if (closure != null) Modifier.semantics { stateDescription = closureText } else Modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = dayShort(date.dayOfWeek).uppercase(),
            fontSize = 10.sp,
            fontWeight = FontWeight.SemiBold,
            letterSpacing = 0.5.sp,
            color = if (date.isWeekend()) DarkGold else DeepNavy.copy(alpha = 0.55f)
        )
        Box(
            modifier = Modifier
                .padding(top = 2.dp)
                .size(24.dp)
                .clip(CircleShape)
                .then(if (isToday) Modifier.background(GoldMetallicBrush) else Modifier),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = date.day.toString(),
                fontSize = 14.sp,
                fontWeight = FontWeight.Bold,
                color = DeepNavy
            )
        }
        if (weather != null) {
            CompositionLocalProvider(LocalContentColor provides DeepNavy.copy(alpha = 0.75f)) {
                WeatherBadge(weather, iconSize = 12.dp, textStyle = MaterialTheme.typography.labelSmall)
            }
        }
        if (specials != null) {
            CompositionLocalProvider(LocalContentColor provides DeepNavy.copy(alpha = 0.75f)) {
                SpecialDayMarker(specials, maxWidth = width - 6.dp, modifier = Modifier.padding(horizontal = 3.dp))
            }
        }
        if (closure != null) DayBadge(stringResource(Res.string.day_closed), ClosedGrey)
        if (shifts.isNotEmpty()) {
            // Red: unfilled shifts publishing would remove; gold: open shifts offered to the team.
            when {
                unfilledCount > 0 -> DayBadge(stringResource(Res.string.roster_unfilled_short, unfilledCount), ConflictRed)
                openCount > 0 -> DayBadge(stringResource(Res.string.roster_open_short, openCount), DarkGold)
                else -> Icon(
                    Icons.Default.CheckCircle,
                    contentDescription = stringResource(Res.string.roster_all_filled),
                    tint = AvailableGreen.copy(alpha = 0.8f),
                    modifier = Modifier.padding(top = 3.dp).size(14.dp)
                )
            }
            if (unfilledCount > 0 && openCount > 0) {
                DayBadge(stringResource(Res.string.roster_open_short, openCount), DarkGold)
            }
            // SH-47: no shift lead, or only people who need supervision (soft).
            if (warning != null) {
                Icon(
                    Icons.Default.SupervisorAccount,
                    contentDescription = warning.text(),
                    tint = ExpiringAmber,
                    modifier = Modifier.padding(top = 2.dp).size(14.dp)
                )
            }
        }
        // SH-54: too few / just right / too many for the day's expected sales.
        if (staffing != null) StaffingChip(staffing, Modifier.padding(top = 3.dp))
    }
}

@Composable
private fun DayBadge(text: String, color: Color) {
    Box(
        modifier = Modifier
            .padding(top = 3.dp)
            .clip(RoundedCornerShape(50))
            .background(color.copy(alpha = 0.14f))
            .padding(horizontal = 6.dp, vertical = 1.dp)
    ) {
        Text(text, color = color, fontSize = 9.sp, lineHeight = 11.sp, fontWeight = FontWeight.Bold, maxLines = 1)
    }
}

/** SH-158: the ids of [shifts] among these (a cell's own marks); empty: the shared empty set. */
internal fun Set<String>.onlyOf(shifts: List<Shift>): Set<String> =
    if (isEmpty() || shifts.isEmpty()) emptySet() else shifts.mapNotNullTo(HashSet()) { it.id.takeIf { id -> id in this } }.ifEmpty { emptySet() }

/** SH-158: the entries of [shifts] among these (a cell's own warnings); none: the shared empty map. */
internal fun <V> Map<String, V>.onlyOf(shifts: List<Shift>): Map<String, V> {
    if (isEmpty() || shifts.isEmpty()) return emptyMap()
    val own = shifts.mapNotNull { shift -> get(shift.id)?.let { shift.id to it } }
    return if (own.isEmpty()) emptyMap() else own.toMap()
}

@Composable
fun ShiftCell(
    shifts: List<Shift>,
    date: LocalDate,
    today: LocalDate,
    pref: DayPreference?,
    availabilitySlots: List<AvailabilitySlot>,
    conflictingShiftIds: Set<String> = emptySet(),
    /** SH-112: shifts a labour-code warning points at. */
    labourWarningShiftIds: Set<String> = emptySet(),
    /** SH-135: the person's time at their other workplaces that day. */
    busyElsewhere: List<BusyElsewhere> = emptyList(),
    /** SH-135: shifts clashing with work elsewhere (overlap: red; short rest: amber). */
    elsewhereIssues: Map<String, ElsewhereIssue> = emptyMap(),
    closed: Boolean = false,
    /** SH-98: wider on a big window, where the whole month fits. */
    width: Dp = GridCellMinWidth,
    /** SH-133: each shift's warnings, explained on hover and from its mark. */
    issuesByShiftId: Map<String, List<RosterIssue>> = emptyMap(),
    /** SH-133: the popover's "Open the shift". */
    onOpenShift: ((Shift) -> Unit)? = null,
    /** SH-169: picked for a template (Shift/Ctrl/Cmd+click or Space): screen readers hear it. */
    selected: Boolean = false,
    /** SH-210: the person's job interviews that day (their own kind of event, not a shift). */
    interviews: List<Interview> = emptyList(),
    /** SH-223: approved remote work or a work event that day: a small mark in the corner. */
    workMarks: Set<com.evoapps.evoshift.domain.model.WorkRequestKind> = emptySet(),
    onClick: () -> Unit
) {
    // The ripple indication draws the hover and press states itself: no per-cell hover listener.
    Box(
        modifier = Modifier
            .width(width)
            .fillMaxHeight()
            .background(columnTint(date, today, closed))
            .padding(horizontal = 3.dp, vertical = 5.dp)
            .clip(RoundedCornerShape(10.dp))
            .handCursor()
            // SH-169: the grid is one Tab stop (the arrows move between cells); screen readers
            // still reach every cell and its click.
            .focusProperties { canFocus = false }
            .clickable(onClick = onClick)
            .semantics { this.selected = selected },
        contentAlignment = Alignment.Center
    ) {
        if (shifts.isEmpty() && interviews.isNotEmpty()) {
            Column(Modifier.fillMaxSize(), verticalArrangement = Arrangement.spacedBy(3.dp)) {
                interviews.forEach { InterviewChip(it, compact = interviews.size > 1, modifier = Modifier.weight(1f)) }
            }
        } else if (shifts.isEmpty() && busyElsewhere.isNotEmpty()) {
            BusyElsewhereCell(busyElsewhere)
        } else if (shifts.isEmpty()) {
            EmptyCell(pref, availabilitySlots)
        } else {
            Column(Modifier.fillMaxSize(), verticalArrangement = Arrangement.spacedBy(3.dp)) {
                interviews.forEach { InterviewChip(it, compact = true, modifier = Modifier.weight(0.7f)) }
                shifts.forEach { shift ->
                    key(shift.id) {
                        val elsewhere = elsewhereIssues[shift.id]
                        ShiftCard(
                            shift = shift,
                            isConflict = shift.conflictMetadata != null || shift.id in conflictingShiftIds || elsewhere == ElsewhereIssue.OVERLAP,
                            labourWarning = shift.id in labourWarningShiftIds || elsewhere == ElsewhereIssue.SHORT_REST,
                            compact = shifts.size > 1,
                            modifier = Modifier.weight(1f),
                            issues = issuesByShiftId[shift.id].orEmpty(),
                            onOpenShift = onOpenShift?.let { open -> { open(shift) } }
                        )
                    }
                }
            }
        }
        if (workMarks.isNotEmpty()) WorkMarkBadge(workMarks, Modifier.align(Alignment.TopEnd))
    }
}

/** Test tag of a cell's remote-work or work-event mark. */
const val WORK_MARK_TAG = "roster_work_mark"

/**
 * SH-223: "Remote" (a house) or "At a work event" (a calendar) in a cell's corner, also the
 * person's schedule's: the shift stays, the mark says where it is worked.
 */
@Composable
fun WorkMarkBadge(marks: Set<com.evoapps.evoshift.domain.model.WorkRequestKind>, modifier: Modifier = Modifier) {
    val remote = com.evoapps.evoshift.domain.model.WorkRequestKind.REMOTE_WORK in marks
    val label = stringResource(if (remote) Res.string.remote_badge else Res.string.event_badge)
    Box(
        modifier = modifier
            .testTag(WORK_MARK_TAG)
            .padding(2.dp)
            .clip(RoundedCornerShape(6.dp))
            .background(DeepNavy)
            .padding(horizontal = 3.dp, vertical = 1.dp)
            .semantics { contentDescription = label },
        contentAlignment = Alignment.Center
    ) {
        Icon(
            if (remote) Icons.Default.Home else Icons.Default.Event,
            contentDescription = null,
            tint = Color.White,
            modifier = Modifier.size(12.dp)
        )
    }
}

/** SH-210: each day's interviews with the names of who takes part (the phone's day list). */
private fun interviewsByDate(state: com.evoapps.evoshift.viewmodels.RosterDetailUiState): Map<LocalDate, List<Pair<Interview, String>>> {
    val names = state.availableEmployees.associate { it.uid to it.displayName }
    return state.interviewsByUserAndDate.values.flatMap { it.entries }
        .groupBy({ it.key }, { it.value }).mapValues { (_, lists) ->
            lists.flatten().distinctBy { it.id }.sortedBy { it.start }.map { interview ->
                interview to interview.participantIds.joinToString { names[it] ?: it }
            }
        }
}

/** SH-210: the tags of interviews in the grid. */
object InterviewGridTags {
    fun cell(interviewId: String) = "grid_interview_$interviewId"
}

/** The violet of interview events (not a shift colour), dark text on a light tint (contrast AA). */
val InterviewTint = Color(0xFFEDE4FA)
val InterviewInk = Color(0xFF4A2380)

/**
 * SH-210: a job interview in a person's cell: "Job interview" with its times, violet with a dashed
 * edge, unlike any shift. Not a shift: it opens nothing here (the applicant's screen manages it).
 */
@Composable
fun InterviewChip(interview: Interview, compact: Boolean, modifier: Modifier = Modifier) {
    val label = stringResource(Res.string.interview_title)
    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(8.dp))
            .background(InterviewTint)
            .border(1.dp, InterviewInk.copy(alpha = 0.55f), RoundedCornerShape(8.dp))
            .padding(horizontal = 3.dp, vertical = 2.dp)
            .testTag(InterviewGridTags.cell(interview.id)),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Text(
            label, fontSize = 8.sp, lineHeight = 9.sp, color = InterviewInk, fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center, maxLines = if (compact) 1 else 2, overflow = TextOverflow.Ellipsis
        )
        Text(
            "${interview.startTime}–${interview.endTime}", fontSize = 9.sp, lineHeight = 10.sp, color = InterviewInk,
            maxLines = 1
        )
    }
}

/**
 * SH-135: a day the person works at another workplace: "Busy at another workplace" with its name
 * and times (the same owner), or "Busy (another employer)" with the times only. Still tappable:
 * a shift that fits around it can be added.
 */
@Composable
private fun BusyElsewhereCell(busy: List<BusyElsewhere>) {
    val sameOwner = busy.all { it.sameOwner }
    val label = stringResource(if (sameOwner) Res.string.busy_elsewhere_same_owner else Res.string.busy_elsewhere_other_employer)
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(DeepNavy.copy(alpha = 0.06f))
            .hatched(DeepNavy.copy(alpha = 0.08f))
            .border(1.dp, DeepNavy.copy(alpha = 0.12f), RoundedCornerShape(10.dp))
            .testTag(BusyElsewhereTags.CELL),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
            Text(
                label,
                fontSize = 8.sp,
                lineHeight = 9.sp,
                color = DeepNavy.copy(alpha = 0.75f),
                textAlign = TextAlign.Center,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.padding(horizontal = 3.dp)
            )
            busy.forEach { b ->
                Text(
                    listOfNotNull(b.workplaceName, busyTimes(b)).joinToString(" "),
                    fontSize = 8.sp,
                    lineHeight = 9.sp,
                    color = DeepNavy.copy(alpha = 0.6f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.padding(horizontal = 3.dp)
                )
            }
        }
    }
}

/**
 * SH-135, the assign sheet: the person's shifts at their other workplaces that day, and the rest
 * to keep around them (a company rule: under the labour code each employer counts separately).
 */
@Composable
private fun BusyElsewhereCard(busy: List<BusyElsewhere>) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = 0.08f))
            .padding(horizontal = 16.dp, vertical = 12.dp)
            .testTag(BusyElsewhereTags.SHEET),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        busy.forEach { b ->
            Text(
                stringResource(if (b.sameOwner) Res.string.busy_elsewhere_same_owner else Res.string.busy_elsewhere_other_employer),
                color = Color.White,
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp
            )
            Text(listOfNotNull(b.workplaceName, busyTimes(b)).joinToString(" · "), color = Color.White.copy(alpha = 0.8f), fontSize = 13.sp)
        }
        Text(stringResource(Res.string.busy_elsewhere_rest_note), color = Color.White.copy(alpha = 0.7f), fontSize = 12.sp)
    }
}

/** "08:00–16:00" of a shift elsewhere. */
internal fun busyTimes(busy: BusyElsewhere): String =
    "${busy.plannedTime.start.substring(11, 16)}–${busy.plannedTime.end.substring(11, 16)}"

object BusyElsewhereTags {
    const val CELL = "busy_elsewhere_cell"
    const val SHEET = "busy_elsewhere_sheet"
}

/** A free day of a person: their availability, if they gave it, and a quiet "add" affordance. */
@Composable
private fun EmptyCell(pref: DayPreference?, availabilitySlots: List<AvailabilitySlot>) {
    val status = pref?.status
    val accent = when (status) {
        AvailabilityStatus.AVAILABLE -> AvailableGreen
        AvailabilityStatus.UNAVAILABLE -> UnavailableRed
        else -> DeepNavy
    }
    val slotLabel = availabilitySlots.find { it.id == pref?.preferredSlotId }?.label
    val surface = when (status) {
        AvailabilityStatus.AVAILABLE -> AvailableGreen.copy(alpha = 0.07f)
        AvailabilityStatus.UNAVAILABLE -> UnavailableRed.copy(alpha = 0.05f)
        else -> DeepNavy.copy(alpha = 0.025f)
    }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(surface)
            .then(if (status == AvailabilityStatus.UNAVAILABLE) Modifier.hatched(UnavailableRed.copy(alpha = 0.12f)) else Modifier)
            .border(1.dp, accent.copy(alpha = 0.1f), RoundedCornerShape(10.dp)),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
            when (status) {
                AvailabilityStatus.UNAVAILABLE -> Icon(
                    Icons.Default.Block, null, tint = UnavailableRed.copy(alpha = 0.55f), modifier = Modifier.size(14.dp)
                )
                else -> Icon(
                    Icons.Default.Add, null,
                    tint = accent.copy(alpha = if (status == null) 0.25f else 0.6f),
                    modifier = Modifier.size(16.dp)
                )
            }
            if (slotLabel != null && status == AvailabilityStatus.AVAILABLE) {
                Text(
                    slotLabel,
                    fontSize = 8.sp,
                    color = AvailableGreen,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.padding(horizontal = 3.dp)
                )
            }
            if (!pref?.comment.isNullOrBlank()) {
                Icon(Icons.AutoMirrored.Filled.Message, null, tint = accent.copy(alpha = 0.7f), modifier = Modifier.size(10.dp))
            }
        }
    }
}

/**
 * A shift in the grid: navy metal with a gold edge; red edge and mark when it conflicts. SH-133:
 * hovering it explains its [issues]; its mark opens them as a popover with "Open the shift".
 */
@Composable
private fun ShiftCard(
    shift: Shift,
    isConflict: Boolean,
    compact: Boolean,
    modifier: Modifier = Modifier,
    labourWarning: Boolean = false,
    issues: List<RosterIssue> = emptyList(),
    onOpenShift: (() -> Unit)? = null
) {
    val start = shift.plannedTime.start.substring(11, 16)
    val end = shift.plannedTime.end.substring(11, 16)
    val explain = rememberExplainState()
    val described = issues.isNotEmpty()
    val marksDescription = stringResource(Res.string.issue_shift_marks, issues.size)
    // A mark to tap: the red triangle for a conflict, the amber gavel for the labour code.
    val mark: @Composable () -> Unit = {
        val markModifier = Modifier.size(if (compact) 16.dp else 18.dp)
            .then(if (described) Modifier.clip(CircleShape).explainOnClick(explain, marksDescription).testTag(RosterIssueTags.shift(shift.id)) else Modifier)
        Box(markModifier, contentAlignment = Alignment.Center) {
            if (isConflict) {
                Icon(Icons.Default.Warning, null, tint = ConflictRed, modifier = Modifier.size(11.dp))
            } else {
                Icon(
                    Icons.Default.Gavel,
                    contentDescription = stringResource(Res.string.roster_shift_labour_warning).takeIf { !described },
                    tint = LabourAmber,
                    modifier = Modifier.size(11.dp)
                )
            }
        }
    }
    val accent = if (isConflict) ConflictRed else DarkGold
    // SH-112: a conflict's red wins; a labour-code warning alone is amber.
    val edge = when {
        isConflict -> SolidColor(ConflictRed)
        labourWarning -> SolidColor(LabourAmber)
        else -> GoldMetallicBrush
    }
    Box(modifier) {
    Row(
        modifier = Modifier
            .fillMaxSize()
            .then(if (described) Modifier.explainOnHover(explain) else Modifier)
            // No per-card shadow: hundreds of them made large grids slow on the web canvas.
            // SH-158: an optimistic shift fades in at half strength; the saved one shows at once.
            .pendingFade(shift.id.isPending)
            .clip(RoundedCornerShape(10.dp))
            .background(CardMetallicBrush)
            .border(0.5.dp, DarkGold.copy(alpha = 0.35f), RoundedCornerShape(10.dp))
            // SH-263: "Show" on the unpublished-changes banner rings the changed shifts.
            .then(
                if (shift.id in LocalUnpublishedHighlight.current) {
                    Modifier.border(2.dp, UnpublishedEdge, RoundedCornerShape(10.dp)).testTag(UnpublishedTags.shift(shift.id))
                } else Modifier
            )
    ) {
        Box(Modifier.width(3.dp).fillMaxHeight().background(edge))
        Column(
            modifier = Modifier.fillMaxSize().padding(horizontal = 5.dp, vertical = if (compact) 2.dp else 5.dp),
            verticalArrangement = if (compact) Arrangement.Center else Arrangement.SpaceBetween
        ) {
            Row(verticalAlignment = Alignment.Top) {
                Column(Modifier.weight(1f)) {
                    Text(start, fontSize = if (compact) 10.sp else 12.sp, fontWeight = FontWeight.Bold, color = Color.White, lineHeight = 12.sp)
                    Text(end, fontSize = 9.sp, color = Color.White.copy(alpha = 0.6f), lineHeight = 10.sp)
                }
                // Two shifts in a cell have no bottom row: the mark sits by the times.
                if (compact && (isConflict || labourWarning)) mark()
            }
            if (!compact) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    shift.requiredRole?.takeIf { it.isNotBlank() }?.let { role ->
                        Text(
                            role.take(4),
                            fontSize = 8.sp,
                            fontWeight = FontWeight.Bold,
                            color = LightGold,
                            maxLines = 1,
                            modifier = Modifier
                                .clip(RoundedCornerShape(4.dp))
                                .background(Color.White.copy(alpha = 0.08f))
                                .padding(horizontal = 3.dp)
                        )
                    }
                    Spacer(Modifier.weight(1f))
                    if (isConflict || labourWarning) {
                        mark()
                    } else if (shift.hasUnpublishedChanges && shift.isPublished) {
                        // Changed after publishing: the team sees it with the next publish.
                        Box(Modifier.size(6.dp).clip(CircleShape).background(LightGold))
                    }
                }
            }
        }
    }
    if (described) {
        ExplainPopups(
            explain,
            tooltip = { ShiftIssuesCard(shift, issues) },
            popover = { close -> ShiftIssuesCard(shift, issues, onOpenShift = onOpenShift?.let { open -> { close(); open() } }, onClose = close) }
        )
    }
    }
}

/** Light diagonal lines over an unavailable day. */
private fun Modifier.hatched(color: Color): Modifier = drawBehind {
    val step = 7.dp.toPx()
    var x = -size.height
    while (x < size.width) {
        drawLine(color, Offset(x, size.height), Offset(x + size.height, 0f), strokeWidth = 1.dp.toPx())
        x += step
    }
}

@Composable
fun DayDetailsSheetContent(
    shifts: List<Shift>,
    closure: DayClosure? = null,
    onShiftClick: (Shift) -> Unit,
    /** SH-47: what the day is missing (shift lead, someone independent). */
    warning: DayStaffAlert? = null,
    /** SH-54: the day's staffing hint, its reasons and what to change. */
    staffing: DayStaffingHint? = null,
    currency: String = DEFAULT_CURRENCY,
    /** SH-112: the labour-code warnings by shift id (shown under each shift they point at). */
    labourWarnings: Map<String, List<LabourWarning>> = emptyMap(),
    /** SH-133: every warning by shift id, explained under each shift (replaces [labourWarnings]). */
    issues: Map<String, List<RosterIssue>> = emptyMap(),
    /** Adding and deleting shifts here; null when the month cannot be changed by this person. */
    editing: DayShiftEditing? = null,
    /** Each shift's employer cost (null: not priced); null for those who may not see money. */
    costOf: ((Shift) -> Double?)? = null,
    /** People's names by user id (to name those without a pay rate). */
    names: Map<String, String> = emptyMap(),
    /** SH-147: the day whose people without pay terms are named, with "Set pay" (money roles only). */
    missingPay: MissingPayScope? = null,
    /** SH-167: "Assign" on each unassigned shift and its person picker; null: not offered. */
    assigning: DayAssigning? = null,
    /** SH-172: the team's answers for the day (per slot, who); null: none to show. */
    answers: com.evoapps.evoshift.domain.schedule.DayAnswerSummary? = null,
    /** SH-227: the day's events and special days, in words (the header's marker in full). */
    specials: DaySpecials? = null
) {
    if (specials != null) {
        CompositionLocalProvider(LocalContentColor provides LightGold) {
            com.evoapps.evoshift.ui.util.SpecialDaysLine(specials, modifier = Modifier.padding(bottom = 12.dp))
        }
    }
    // SH-167: the picker takes the sheet's place while it is open (the shift still unassigned).
    val picking = assigning?.pickerShiftId?.let { id -> shifts.firstOrNull { it.id == id && it.userId == null } }
    MotionContent(picking, Modifier.fillMaxWidth(), label = "dayPicker") { pickerShift ->
        if (pickerShift != null && assigning != null) {
            DayAssignPicker(pickerShift, assigning)
        } else {
            DayShiftsContent(
                shifts, closure, onShiftClick, warning, staffing, currency, labourWarnings, issues, editing, costOf, names, missingPay, assigning, answers
            )
        }
    }
}

@Composable
private fun DayShiftsContent(
    shifts: List<Shift>,
    closure: DayClosure?,
    onShiftClick: (Shift) -> Unit,
    warning: DayStaffAlert?,
    staffing: DayStaffingHint?,
    currency: String,
    labourWarnings: Map<String, List<LabourWarning>>,
    issues: Map<String, List<RosterIssue>>,
    editing: DayShiftEditing?,
    costOf: ((Shift) -> Double?)?,
    names: Map<String, String>,
    missingPay: MissingPayScope?,
    assigning: DayAssigning?,
    answers: com.evoapps.evoshift.domain.schedule.DayAnswerSummary?
) {
    val assignedShifts = shifts.filter { it.userId != null }.sortedBy { it.plannedTime.start }
    val unassignedShifts = shifts.filter { it.userId == null }.sortedBy { it.plannedTime.start }

    Column(verticalArrangement = Arrangement.spacedBy(20.dp)) {
        missingPay?.let { MissingPayBanner(it, onDark = true) }
        answers?.let { DayAnswersPanel(it) }
        if (warning != null) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.SupervisorAccount, null, tint = Color(0xFFFFB74D), modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text(warning.text(), color = Color(0xFFFFB74D), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold)
            }
        }
        if (staffing != null) StaffingHintLines(staffing, currency, color = Color.White.copy(alpha = 0.8f), onDark = true, names = names)
        // SH-55: closed by the Sunday policy; shifts can still be added by hand.
        closure?.let {
            Text(closureLabel(it), color = Color.White, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
        }
        if (shifts.isEmpty()) {
            Text(
                stringResource(Res.string.schedule_no_shifts),
                color = Color.White.copy(alpha = 0.6f),
                style = MaterialTheme.typography.bodyMedium
            )
        }
        if (assignedShifts.isNotEmpty()) {
            DialogSection(stringResource(Res.string.roster_assigned_shifts)) {
                // SH-158: a shift added or deleted slides the list instead of jumping.
                Column(Modifier.motionContentSize(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    assignedShifts.forEach { shift ->
                        key(shift.id) {
                            ShiftSummaryItem(
                                shift, onClick = { onShiftClick(shift) }, unsupervised = warning != null && shift.id in warning.shiftIds,
                                labourWarnings = labourWarnings[shift.id].orEmpty(),
                                issues = issues[shift.id].orEmpty(),
                                onDelete = editing?.onDelete?.let { delete -> { delete(shift) } },
                                costLabel = costOf?.let { cost -> shiftCostLabel(cost(shift), currency) }
                            )
                        }
                    }
                }
            }
        }
        if (unassignedShifts.isNotEmpty()) {
            DialogSection(stringResource(Res.string.roster_unassigned_shifts)) {
                Column(Modifier.motionContentSize(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    unassignedShifts.forEach { shift ->
                        key(shift.id) {
                            ShiftSummaryItem(
                                shift, onClick = { onShiftClick(shift) }, onDelete = editing?.onDelete?.let { delete -> { delete(shift) } },
                                costLabel = costOf?.let { cost -> cost(shift)?.let { formatMoney(it, currency) } },
                                onAssign = assigning?.let { a -> { a.onOpen(shift) } }
                            )
                        }
                    }
                }
            }
        }
        if (editing != null) AddShiftEntry(editing)
    }
}

/**
 * What the day's details may change: add an unassigned shift (from a template or custom times) and
 * delete a shift (the screen asks first). Given only to those who build a month still being built.
 */
class DayShiftEditing(
    val templates: List<ShiftTemplate>,
    val onAddFromTemplate: (ShiftTemplate) -> Unit,
    val onAddCustom: (start: String, end: String, role: String?) -> Unit,
    /** Asks to delete the shift (a confirmation follows); null: deleting is not offered. */
    val onDelete: ((Shift) -> Unit)?,
    /** SH-115: the budget effect of a new unassigned shift of [hours]; null: no budget. */
    val budgetEffect: ((hours: Double) -> BudgetEffect?)? = null,
    val currency: String = DEFAULT_CURRENCY,
    /** The estimated employer cost of a new unassigned shift of [hours]; null: not shown (no money role). */
    val shiftCost: ((hours: Double) -> Breakdown?)? = null,
    /** The workplace's roles (SH-130): a custom shift's role is picked from them. */
    val availableRoles: List<String> = emptyList(),
    /** SH-204: the day, the team and the batched save of the add-shift dialog; null: the plain form. */
    val adding: AddShiftSupport? = null
)

/** An assigned shift's cost on its card: the amount, or "No pay rate" when it cannot be priced. */
@Composable
private fun shiftCostLabel(cost: Double?, currency: String): String =
    cost?.let { formatMoney(it, currency) } ?: stringResource(Res.string.roster_shift_no_rate)

/** "Estimated cost: 240,00 zł": a shift's employer cost for the person (money roles only). */
@Composable
fun ShiftCostLine(cost: Breakdown, currency: String, explain: Boolean = true) {
    // SH-152: tap to see what the cost is made of (its snapshot's parts, or the hours at a cost per hour);
    // not inside a template that is itself tapped to add the shift.
    com.evoapps.evoshift.ui.finance.ExplainableAmount(
        stringResource(Res.string.roster_shift_cost, formatMoney(cost.value, currency)),
        cost.takeIf { explain } as com.evoapps.evoshift.domain.explain.Calculation?,
        currency,
        style = MaterialTheme.typography.labelSmall,
        fontWeight = FontWeight.Bold,
        color = LightGold
    )
}

/** Asks before deleting [shift] from the roster: whose it is, its times and day. */
@Composable
fun DeleteShiftConfirmation(shift: Shift, onConfirm: () -> Unit, onDismiss: () -> Unit) {
    val start = shift.plannedTime.start.substringAfter('T').take(5)
    val end = shift.plannedTime.end.substringAfter('T').take(5)
    val day = dayAndDate(LocalDate.parse(shift.date))
    val who = shift.userId?.let { com.evoapps.evoshift.ui.util.personName(shift.userDisplayName) }
    EvoConfirmDialog(
        title = stringResource(Res.string.roster_delete_shift_title),
        text = if (who != null) stringResource(Res.string.roster_delete_shift_text_assigned, who, start, end, day)
            else stringResource(Res.string.roster_delete_shift_text_unassigned, start, end, day),
        confirmLabel = stringResource(Res.string.delete),
        onConfirm = onConfirm,
        onDismiss = onDismiss,
        destructive = true,
        icon = Icons.Default.Delete
    )
}

@Composable
fun ShiftSummaryItem(
    shift: Shift,
    onClick: () -> Unit,
    /** SH-104: the person needs supervision and is, at some time of this shift, without it. */
    unsupervised: Boolean = false,
    /** SH-112: the labour-code warnings that point at this shift. */
    labourWarnings: List<LabourWarning> = emptyList(),
    /** SH-133: all of the shift's warnings, explained with their legal basis (replace [labourWarnings]). */
    issues: List<RosterIssue> = emptyList(),
    /** Asks to delete the shift; null: not offered. */
    onDelete: (() -> Unit)? = null,
    /** Its employer cost ("240,00 zł", or "No pay rate"), under the times; null: not shown. */
    costLabel: String? = null,
    /** SH-167: "Assign" under an unassigned shift: its person picker in the same sheet; null: not offered. */
    onAssign: (() -> Unit)? = null
) {
    val start = shift.plannedTime.start.substring(11, 16)
    val end = shift.plannedTime.end.substring(11, 16)

    ProvideScreenColors {
    Column(
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White)
            .border(1.dp, DeepNavy.copy(alpha = 0.1f), RoundedCornerShape(12.dp))
    ) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .handCursor()
            .clickable(onClick = onClick)
            .padding(16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(modifier = Modifier.weight(1f)) {
            shift.requiredRole?.let { role ->
                Text(
                    text = role,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }
            val candidate = shift.swapRequest?.takeIf { it.status == SwapStatus.TAKEN_PENDING }?.candidateName
            Text(
                text = when {
                    shift.userId != null -> com.evoapps.evoshift.ui.util.personName(shift.userDisplayName)
                    shift.isOpen && candidate != null -> stringResource(Res.string.roster_open_shift_claimed, candidate)
                    shift.isOpen -> stringResource(Res.string.roster_open_shift_label)
                    else -> stringResource(Res.string.roster_no_employee)
                },
                style = MaterialTheme.typography.bodySmall,
                color = if (shift.userId == null && shift.isOpen) DarkGold else DeepNavy.copy(alpha = 0.7f),
                fontWeight = if (shift.userId == null && shift.isOpen) FontWeight.Bold else null
            )
            if (shift.requiredSkills.isNotEmpty()) {
                Text(
                    text = stringResource(Res.string.roster_skills_list, shift.requiredSkills.joinToString(", ")),
                    style = MaterialTheme.typography.labelSmall,
                    color = DeepNavy.copy(alpha = 0.5f)
                )
            }
            if (issues.isEmpty()) labourWarnings.forEach { labour ->
                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(top = 4.dp)) {
                    Icon(Icons.Default.Gavel, null, tint = LabourAmber, modifier = Modifier.size(12.dp))
                    Spacer(Modifier.width(4.dp))
                    Text(labour.text(), style = MaterialTheme.typography.labelSmall, color = LabourAmber, fontWeight = FontWeight.Bold)
                }
            }
            // SH-133: the shift's own warnings (the day's lead shows in the day's header).
            issues.filter { it.userId != null }.forEach { issue ->
                val tint = if (issue.isConflict) ConflictRed else LabourAmber
                Row(verticalAlignment = Alignment.Top, modifier = Modifier.padding(top = 4.dp)) {
                    Icon(if (issue.isConflict) Icons.Default.Warning else Icons.Default.Gavel, null, tint = tint, modifier = Modifier.padding(top = 1.dp).size(12.dp))
                    Spacer(Modifier.width(4.dp))
                    Column {
                        Text(issue.text(), style = MaterialTheme.typography.labelSmall, color = tint, fontWeight = FontWeight.Bold)
                        issue.basisText()?.let { Text(it, style = MaterialTheme.typography.labelSmall, color = DeepNavy.copy(alpha = 0.6f)) }
                    }
                }
            }
        }

        Column(horizontalAlignment = Alignment.End) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                if (unsupervised) {
                    Icon(
                        Icons.Default.School,
                        contentDescription = stringResource(Res.string.roster_shift_unsupervised),
                        tint = Color(0xFFFFB74D),
                        modifier = Modifier.padding(end = 4.dp).size(16.dp)
                    )
                }
                Text(
                    text = "$start - $end",
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }
            costLabel?.let {
                Text(it, style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, color = DeepNavy.copy(alpha = 0.6f))
            }
            // Clock times are empty until the person clocks in / out (still working: no end yet).
            shift.actualTime?.takeIf { it.start.length >= 16 }?.let { actual ->
                val aStart = actual.start.substring(11, 16)
                val aEnd = if (actual.end.length >= 16) actual.end.substring(11, 16) else "…"
                Text(
                    text = stringResource(Res.string.roster_actual_range, aStart, aEnd),
                    style = MaterialTheme.typography.labelSmall,
                    color = Color(0xFF4CAF50),
                    fontWeight = FontWeight.Bold
                )
                // SH-116: the break going on, else the breaks taken.
                BreakRules.open(shift.breaks)?.let { b ->
                    Text(
                        text = stringResource(Res.string.at_work_break_since, b.start.substringAfter('T').take(5)),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color(0xFF8A5A00),
                        fontWeight = FontWeight.Bold
                    )
                } ?: BreakRules.endedMinutes(shift.breaks).takeIf { it > 0 }?.let { minutes ->
                    Text(
                        text = stringResource(Res.string.at_work_breaks_total, minutes.toInt()),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color(0xFF4CAF50)
                    )
                }
                // SH-107: clocked on the workplace's tablet (and, if so, sent late after being offline);
                // SH-111: or by scanning the tablet's QR code in the app.
                shift.clockAudit?.takeIf { it.viaKiosk || it.viaQr }?.let { audit ->
                    val via = listOfNotNull(
                        stringResource(Res.string.kiosk_via_tablet).takeIf { audit.viaKiosk },
                        stringResource(Res.string.kiosk_via_qr).takeIf { audit.viaQr },
                        stringResource(Res.string.kiosk_synced_late).takeIf { audit.syncedLate }
                    )
                    Text(
                        text = via.joinToString(" · "),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color(0xFF4CAF50)
                    )
                }
                // SH-106: clocked outside the workplace's area or without a location.
                com.evoapps.evoshift.ui.user.locationFlagText(shift.clockAudit?.locationFlag)?.let {
                    Text(
                        text = it,
                        style = MaterialTheme.typography.labelSmall,
                        color = com.evoapps.evoshift.ui.user.LocationFlagColor,
                        fontWeight = FontWeight.Bold
                    )
                }
            }
        }
        if (onDelete != null) {
            // SH-163: a 48 dp target around the same 36 dp button, right beside the tappable card.
            IconButtonWithTooltip(onClick = onDelete, modifier = Modifier.padding(start = 4.dp).minimumInteractiveComponentSize().size(36.dp).handCursor(), tooltip = stringResource(Res.string.roster_delete_shift)) {
                Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.roster_delete_shift), tint = DeepNavy.copy(alpha = 0.6f))
            }
        }
    }
    if (onAssign != null) {
        // SH-167: one tap to the people for this shift, without leaving the day.
        val assignDescription = stringResource(Res.string.roster_picker_title, shift.pickerLabel())
        Button(
            onClick = onAssign,
            modifier = Modifier
                .padding(start = 16.dp, end = 16.dp, bottom = 12.dp)
                .fillMaxWidth()
                .handCursor()
                .semantics { contentDescription = assignDescription },
            shape = RoundedCornerShape(8.dp),
            colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White)
        ) {
            Icon(Icons.Default.PersonAdd, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text(stringResource(Res.string.roster_day_assign), fontWeight = FontWeight.Bold)
        }
    }
    }
    }
}

/**
 * Edits one shift: who works it (picked from the workplace's employees, or nobody = open shift),
 * the role and the planned / approved times. Times are clock times (`8:00`, `22:30`); a shift
 * ending at or before its start ends the next day.
 */
@Composable
fun ShiftEditDialog(
    shift: Shift,
    employees: List<User>,
    onDismiss: () -> Unit,
    /** The last argument: the corrected breaks (SH-116), null when the shift has no clock times. */
    onUpdate: (String, String?, String?, List<String>, TimeRange, TimeRange?, Boolean, List<ShiftBreak>?) -> Unit,
    /** Each person's answer for the shift's day (null: none given), shown in the picker. */
    availabilityFor: (String) -> DayPreference? = { null },
    availabilitySlots: List<AvailabilitySlot> = emptyList(),
    /** SH-115: the budget effect of the shift as edited ([userId] working the hours); null: no budget. */
    budgetEffect: ((userId: String?, hours: Double) -> BudgetEffect?)? = null,
    currency: String = DEFAULT_CURRENCY,
    /** The workplace's roles (SH-130): the role is picked from them. */
    availableRoles: List<String> = emptyList(),
    /** Asks to delete the shift (a confirmation follows); null: not offered. */
    onDelete: (() -> Unit)? = null,
    /** The shift's estimated employer cost as edited ([userId] working the hours); null: not shown (no money role). */
    shiftCost: ((userId: String?, hours: Double) -> Breakdown?)? = null,
    /** SH-167: the shift has started: "Actual time" and breaks are offered (always, once it has clock times). */
    started: Boolean = true,
    /** SH-236: names for "who actually worked" and a split's other part (SH-237: null shows the label, never the id). */
    nameOf: (String) -> String? = { null },
    /** SH-236: "Who worked…", "Split shift…" and "Undo split"; null: not offered. */
    onActualWork: (() -> Unit)? = null,
    onSplit: (() -> Unit)? = null,
    onUndoSplit: (() -> Unit)? = null
) {
    val showActual = started || !shift.actualTime?.start.isNullOrEmpty() || !shift.actualTime?.end.isNullOrEmpty()
    var selectedUserId by remember { mutableStateOf(shift.userId) }
    var open by remember { mutableStateOf(shift.isOpen) }
    var role by remember { mutableStateOf(shift.requiredRole ?: "") }
    var startTimePlanned by remember { mutableStateOf(shift.plannedTime.start.substringAfter('T').take(5)) }
    var endTimePlanned by remember { mutableStateOf(shift.plannedTime.end.substringAfter('T').take(5)) }
    var startTimeActual by remember { mutableStateOf(shift.actualTime?.start?.substringAfter('T')?.take(5).orEmpty()) }
    var endTimeActual by remember { mutableStateOf(shift.actualTime?.end?.substringAfter('T')?.take(5).orEmpty()) }

    val date = remember(shift.date) { LocalDate.parse(shift.date) }
    val plannedStart = parseClockTime(startTimePlanned)
    val plannedEnd = parseClockTime(endTimePlanned)
    val planned = if (plannedStart != null && plannedEnd != null) {
        runCatching { plannedTimeRange(date, plannedStart, plannedEnd) }.getOrNull()
    } else null
    // Approved times are optional, but both or neither.
    val actualBlank = startTimeActual.isBlank() && endTimeActual.isBlank()
    val actualStart = parseClockTime(startTimeActual)
    val actualEnd = parseClockTime(endTimeActual)
    val actual = if (actualStart != null && actualEnd != null) {
        runCatching { plannedTimeRange(date, actualStart, actualEnd) }.getOrNull()
    } else null
    // SH-116: the breaks, editable once the shift has clock times.
    val breakRows = remember { mutableStateListOf(*shift.breaks.map { BreakRow.of(it) }.toTypedArray()) }
    val breaks = actual?.let { range -> breakRows.toBreaks(range) }
    val breakProblem = when {
        actual == null || breakRows.isEmpty() -> null
        breaks == null -> BreakProblem.UNREADABLE
        else -> BreakRules.validate(breaks, actual.start, actual.end)
    }
    val valid = planned != null && (actualBlank || actual != null) && breakProblem == null

    val unassigned = stringResource(Res.string.roster_unassigned)
    // "" stands for nobody; an assignee who left the workplace stays listed under their id.
    val people = remember(employees, selectedUserId) {
        buildList {
            add("")
            employees.sortedBy { it.displayName.lowercase() }.forEach { add(it.uid) }
            selectedUserId?.takeIf { id -> employees.none { it.uid == id } }?.let { add(it) }
        }
    }

    EvoDialog(
        title = stringResource(Res.string.roster_shift_details),
        subtitle = dayAndDate(date),
        icon = Icons.Default.Schedule,
        onDismiss = onDismiss,
        dismissOnClickOutside = false,
        bodyArrangement = Arrangement.spacedBy(24.dp),
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                if (planned != null && (actualBlank || actual != null)) {
                    onUpdate(
                        shift.id, selectedUserId, role.trim().ifBlank { null }, shift.requiredSkills, planned, actual,
                        selectedUserId == null && open, if (actual != null) breaks.orEmpty() else null
                    )
                }
            },
            enabled = valid
        ),
        neutral = onDelete?.let { DialogAction(stringResource(Res.string.roster_delete_shift), it, destructive = true, icon = Icons.Default.Delete) }
    ) {
        DialogSection(stringResource(Res.string.dialog_section_assignment)) {
            EvoDropdown(
                label = stringResource(Res.string.roster_employee),
                options = people,
                selected = selectedUserId ?: "",
                onSelected = { selectedUserId = it.ifBlank { null } },
                optionLabel = { id -> if (id.isBlank()) unassigned else employees.firstOrNull { it.uid == id }?.displayName ?: id },
                optionDetail = { id -> if (id.isNotBlank()) AvailabilityLine(availabilityFor(id), availabilitySlots) }
            )
            selectedUserId?.let { id -> AvailabilityLine(availabilityFor(id), availabilitySlots) }
            // Only an unassigned shift can be offered to the team.
            if (selectedUserId == null) {
                EvoSwitchRow(
                    checked = open,
                    onCheckedChange = { open = it },
                    label = stringResource(Res.string.roster_open_shift_toggle),
                    supporting = stringResource(Res.string.roster_open_shift_hint)
                )
            }
            RoleField(role = role, onRoleChange = { role = it }, availableRoles = availableRoles, optional = true)
        }

        DialogSection(stringResource(Res.string.roster_planned_time)) {
            TimePairFields(
                start = startTimePlanned,
                onStart = { startTimePlanned = it },
                end = endTimePlanned,
                onEnd = { endTimePlanned = it },
                optional = false
            )
            // The shift's cost for the person picked, then (SH-115) what it does to the budget;
            // over budget warns, saving stays allowed.
            if (planned != null) {
                val hours = calculateDurationHours(planned.start, planned.end)
                shiftCost?.invoke(selectedUserId, hours)?.let { ShiftCostLine(it, currency) }
                budgetEffect?.invoke(selectedUserId, hours)?.let { BudgetEffectLines(it, currency) }
            }
        }

        if (showActual) DialogSection(stringResource(Res.string.roster_actual_time)) {
            TimePairFields(
                start = startTimeActual,
                onStart = { startTimeActual = it },
                end = endTimeActual,
                onEnd = { endTimeActual = it },
                optional = true,
                // One of the pair without the other.
                missingError = !actualBlank && (startTimeActual.isBlank() || endTimeActual.isBlank())
            )
        }

        // SH-116: the breaks taken while clocked in; a manager corrects them like the times.
        if (showActual && !actualBlank) {
            DialogSection(stringResource(Res.string.shift_breaks)) {
                breakRows.forEachIndexed { index, row ->
                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.testTag(shiftBreakRowTag(index))) {
                        Box(Modifier.weight(1f)) {
                            TimePairFields(
                                start = row.start,
                                onStart = { breakRows[index] = row.copy(start = it) },
                                end = row.end,
                                onEnd = { breakRows[index] = row.copy(end = it) },
                                optional = false
                            )
                        }
                        IconButtonWithTooltip(onClick = { breakRows.removeAt(index) }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.shift_break_remove)) {
                            Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.shift_break_remove), tint = Color.White.copy(alpha = 0.8f))
                        }
                    }
                }
                breakProblem?.let {
                    Text(breakProblemText(it).asString(), color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
                }
                if (breakRows.size < BreakRules.MAX_BREAKS) {
                    TextButton(onClick = { breakRows.add(BreakRow()) }, modifier = Modifier.handCursor().testTag(SHIFT_BREAK_ADD_TAG)) {
                        // On the navy dialog (EvoDialog): gold, not dark navy.
                        Icon(Icons.Default.Add, contentDescription = null, tint = LightGold)
                        Spacer(Modifier.width(4.dp))
                        Text(stringResource(Res.string.shift_break_add), color = LightGold)
                    }
                }
            }
        }

        // SH-236: who actually worked it, and splitting it when someone falls ill and a colleague takes over.
        if (onActualWork != null || onSplit != null || shift.split != null || shift.notWorked || shift.actualUserId != null) {
            DialogSection(stringResource(Res.string.actual_work_section)) {
                ActualWorkLines(shift, nameOf)
                ActualWorkActions(shift, onActualWork, onSplit, onUndoSplit)
            }
        }

        // SH-118: a note for the person on the shift (ShiftNote.kt), saved on its own.
        if (shift.userId != null) ShiftNoteSection(shift)
    }
}

/** SH-116: test tags of the shift dialog's break editor. */
const val SHIFT_BREAK_ADD_TAG = "shift_break_add"
fun shiftBreakRowTag(index: Int) = "shift_break_row_$index"

/** One break as typed in the shift dialog ("HH:mm"); [original] keeps an unchanged break as it was. */
private data class BreakRow(val start: String = "", val end: String = "", val original: ShiftBreak? = null) {
    companion object {
        fun of(b: ShiftBreak) = BreakRow(b.start.substringAfter('T').take(5), b.end.substringAfter('T').take(5), b)
    }
}

/** The rows as breaks within [actual]; null when one cannot be read. */
private fun List<BreakRow>.toBreaks(actual: TimeRange): List<ShiftBreak>? = map { row ->
    val start = parseClockTime(row.start) ?: return null
    val end = parseClockTime(row.end) ?: return null
    val original = row.original
    if (original != null && original.start.substringAfter('T').take(5) == start && original.end.substringAfter('T').take(5) == end) {
        original
    } else {
        val s = BreakRules.atClock(actual.start, start) ?: return null
        val e = BreakRules.atClock(actual.start, end) ?: return null
        ShiftBreak(s, e, ClockSource.MANAGER)
    }
}

/** A from / to pair of clock times side by side, each with its own format error. */
@Composable
private fun TimePairFields(
    start: String,
    onStart: (String) -> Unit,
    end: String,
    onEnd: (String) -> Unit,
    optional: Boolean,
    missingError: Boolean = false,
    lastImeAction: ImeAction = ImeAction.Next
) {
    Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
        EvoTimeField(
            value = start,
            onValueChange = onStart,
            label = stringResource(Res.string.roster_from),
            optional = optional,
            showErrors = !optional || missingError,
            modifier = Modifier.weight(1f)
        )
        EvoTimeField(
            value = end,
            onValueChange = onEnd,
            label = stringResource(Res.string.roster_to),
            placeholder = "16:00",
            optional = optional,
            showErrors = !optional || missingError,
            imeAction = lastImeAction,
            modifier = Modifier.weight(1f)
        )
    }
}

/** The body of the assign sheet: the person's preference, their shifts, open slots and a new shift. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AssignShiftSheetContent(
    date: LocalDate,
    preference: DayPreference?,
    availabilitySlots: List<AvailabilitySlot>,
    /** The workplace's roles (SH-130): a new shift's role is picked from them. */
    availableRoles: List<String> = emptyList(),
    assignedShifts: List<Shift>,
    skeletonShifts: List<Shift>,
    templates: List<ShiftTemplate>,
    /** SH-115: the budget effect of the person working [hours] in that shift (null: a new one); null: no budget. */
    budgetEffect: ((shiftId: String?, hours: Double) -> BudgetEffect?)? = null,
    currency: String = DEFAULT_CURRENCY,
    /** Each option's estimated employer cost for the person ([shiftId] null: a new shift); null: not shown. */
    shiftCost: ((shiftId: String?, hours: Double) -> Breakdown?)? = null,
    onAddShift: (ShiftTemplate) -> Unit,
    onAssignSkeletonShift: (String) -> Unit,
    onUnassignShift: (String) -> Unit,
    onCreateCustom: (start: String, end: String, role: String?) -> Unit,
    /** Opens the shift's editor (times, person, position), as a tap on it in the day panel; null: not editable here. */
    onEditShift: ((Shift) -> Unit)? = null,
    /** SH-135: the person's work at their other workplaces that day. */
    busyElsewhere: List<BusyElsewhere> = emptyList()
) {
    var expanded by remember { mutableStateOf(false) }

    Column(verticalArrangement = Arrangement.spacedBy(20.dp)) {
        if (preference != null) AvailabilityPreferenceCard(preference, availabilitySlots)
        if (busyElsewhere.isNotEmpty()) BusyElsewhereCard(busyElsewhere)

        // --- Assigned Shifts ---
        if (assignedShifts.isNotEmpty()) {
            // SH-158: an unassigned shift leaves the list smoothly.
            DialogSection(stringResource(Res.string.roster_assigned_shifts), Modifier.motionContentSize()) {
                assignedShifts.forEach { shift ->
                    key(shift.id) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(12.dp))
                                .background(Color.White.copy(alpha = 0.06f))
                                .then(if (onEditShift != null) Modifier.clickable { onEditShift(shift) }.handCursor() else Modifier)
                                .padding(start = 16.dp, end = 4.dp, top = 4.dp, bottom = 4.dp)
                        ) {
                            Text(
                                text = listOfNotNull(
                                    shift.requiredRole,
                                    "${shift.plannedTime.start.substring(11, 16)} – ${shift.plannedTime.end.substring(11, 16)}"
                                ).joinToString(" · "),
                                modifier = Modifier.weight(1f),
                                color = Color.White
                            )
                            if (onEditShift != null) {
                                IconButtonWithTooltip(onClick = { onEditShift(shift) }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.roster_edit_shift)) {
                                    Icon(Icons.Default.Edit, contentDescription = stringResource(Res.string.roster_edit_shift), tint = Color.White)
                                }
                            }
                            TextButton(
                                onClick = { onUnassignShift(shift.id) },
                                colors = ButtonDefaults.textButtonColors(contentColor = ErrorOnNavy),
                                modifier = Modifier.handCursor()
                            ) {
                                Text(stringResource(Res.string.roster_unassign), fontWeight = FontWeight.Bold)
                            }
                        }
                    }
                }
            }
        }

        // --- Skeleton Shifts ---
        DialogSection(stringResource(Res.string.roster_from_skeleton, "${dayShort(date.dayOfWeek)} ${date.day}"), Modifier.motionContentSize()) {
            if (skeletonShifts.isNotEmpty()) {
                skeletonShifts.forEach { shift ->
                    key(shift.id) {
                        val time = "${shift.plannedTime.start.substring(11, 16)} – ${shift.plannedTime.end.substring(11, 16)}"
                        EvoSecondaryButton(
                            DialogAction(
                                stringResource(Res.string.roster_assign_role_time, shift.requiredRole ?: "", time),
                                { onAssignSkeletonShift(shift.id) }
                            ),
                            Modifier.fillMaxWidth()
                        )
                        val hours = calculateDurationHours(shift.plannedTime.start, shift.plannedTime.end)
                        shiftCost?.invoke(shift.id, hours)?.let { ShiftCostLine(it, currency) }
                        budgetEffect?.invoke(shift.id, hours)?.let { BudgetEffectLines(it, currency) }
                    }
                }
            } else {
                Text(
                    stringResource(Res.string.roster_no_open_skeleton_shifts),
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.White.copy(alpha = 0.6f)
                )
            }
        }

        // SH-158: "Add another shift" gives way to the templates and custom times (and back) by fading.
        MotionContent(expanded, Modifier.fillMaxWidth(), label = "addShift") { open ->
            if (!open) {
                EvoSecondaryButton(
                    DialogAction(stringResource(Res.string.roster_add_additional), { expanded = true }, icon = Icons.Default.Add),
                    Modifier.fillMaxWidth()
                )
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(20.dp)) {
                    if (templates.isNotEmpty()) {
                        DialogSection(stringResource(Res.string.roster_from_templates)) {
                            FlowRow(
                                horizontalArrangement = Arrangement.spacedBy(8.dp),
                                verticalArrangement = Arrangement.spacedBy(8.dp),
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                templates.forEach { template ->
                                    Box(
                                        modifier = Modifier
                                            .clip(RoundedCornerShape(12.dp))
                                            .border(1.dp, DarkGold.copy(alpha = 0.6f), RoundedCornerShape(12.dp))
                                            .handCursor()
                                            .clickable { onAddShift(template) }
                                            .padding(horizontal = 14.dp, vertical = 10.dp)
                                    ) {
                                        Column {
                                            Text(
                                                "${template.name} · ${template.startTime.take(5)}–${template.endTime.take(5)}",
                                                style = MaterialTheme.typography.bodySmall,
                                                color = Color.White
                                            )
                                            val templateHours = calculateDurationHours(template.startTime, template.endTime)
                                            shiftCost?.invoke(null, templateHours)?.let { ShiftCostLine(it, currency, explain = false) }
                                            // SH-115: what the shift would add to the budget.
                                            budgetEffect?.invoke(null, templateHours)?.let { effect ->
                                                Text(
                                                    formatMoneyDelta(effect.delta, currency),
                                                    style = MaterialTheme.typography.labelSmall,
                                                    fontWeight = FontWeight.Bold,
                                                    color = if (effect.isOver) ErrorOnNavy else DarkGold
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    var customStart by remember { mutableStateOf("") }
                    var customEnd by remember { mutableStateOf("") }
                    var customRole by remember { mutableStateOf("") }
                    var tried by remember { mutableStateOf(false) }
                    val start = parseClockTime(customStart)
                    val end = parseClockTime(customEnd)
                    val sameTimes = start != null && start == end

                    DialogSection(stringResource(Res.string.roster_create_custom)) {
                        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                            EvoTimeField(
                                value = customStart,
                                onValueChange = { customStart = it },
                                label = stringResource(Res.string.roster_from),
                                showErrors = tried,
                                modifier = Modifier.weight(1f)
                            )
                            EvoTimeField(
                                value = customEnd,
                                onValueChange = { customEnd = it },
                                label = stringResource(Res.string.roster_to),
                                placeholder = "16:00",
                                showErrors = tried,
                                // Overnight shifts (22:00-06:00) are fine; the same start and end is not.
                                error = stringResource(Res.string.time_same_start_end).takeIf { sameTimes },
                                modifier = Modifier.weight(1f)
                            )
                        }
                        RoleField(
                            role = customRole,
                            onRoleChange = { customRole = it },
                            availableRoles = availableRoles,
                            optional = true,
                            imeAction = ImeAction.Done
                        )
                        // The custom shift's cost and (SH-115) what is left, as the times are typed.
                        if (start != null && end != null && !sameTimes) {
                            shiftCost?.invoke(null, calculateDurationHours(start, end))?.let { ShiftCostLine(it, currency) }
                            budgetEffect?.invoke(null, calculateDurationHours(start, end))?.let { BudgetEffectLines(it, currency) }
                        }
                        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                            EvoSecondaryButton(
                                DialogAction(stringResource(Res.string.roster_cancel_addition), { expanded = false }),
                                Modifier.weight(1f)
                            )
                            EvoPrimaryButton(
                                DialogAction(
                                    stringResource(Res.string.roster_assign_shift),
                                    {
                                        tried = true
                                        if (start != null && end != null && !sameTimes) {
                                            onCreateCustom(start, end, customRole.trim().ifBlank { null })
                                        }
                                    }
                                ),
                                Modifier.weight(1f)
                            )
                        }
                    }
                }
            }
        }
    }
}

/** The assignment conflict in the user's language (the domain only reports the facts). */
@Composable
private fun conflictText(conflict: AssignUserToShiftUseCase.AssignmentResult.ConflictFound): String {
    val name = conflict.employeeName ?: stringResource(Res.string.employee)
    val start = conflict.conflictStart.orEmpty()
    val end = conflict.conflictEnd.orEmpty()
    return when {
        conflict.conflictType == ConflictType.EXPIRED_STAFF_CHECK ->
            stringResource(Res.string.conflict_staff_expired, name, conflict.expiredChecks.map { it.lowerLabel() }.joinToString(", "))
        conflict.conflictType == ConflictType.UNAVAILABLE -> stringResource(Res.string.conflict_unavailable)
        conflict.conflictType != ConflictType.DOUBLE_BOOKED -> stringResource(Res.string.conflict_generic)
        conflict.isSameOwner && conflict.workplaceName != null ->
            stringResource(Res.string.conflict_same_owner, name, conflict.workplaceName.orEmpty(), start, end)
        else -> stringResource(Res.string.conflict_other_company, name, start, end)
    }
}

/** A person's answer for a day: available (with the slot) or unavailable, and their comment. */
@Composable
fun AvailabilityPreferenceCard(preference: DayPreference, availabilitySlots: List<AvailabilitySlot>) {
    val slotLabel = availabilitySlots.find { it.id == preference.preferredSlotId }?.label
    val color = if (preference.status == AvailabilityStatus.AVAILABLE) Color(0xFF81C784) else ErrorOnNavy
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = 0.06f))
            .padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(8.dp).clip(CircleShape).background(color))
            Spacer(Modifier.width(8.dp))
            Text(
                text = "${preference.status.label()}${if (slotLabel != null) " ($slotLabel)" else ""}",
                style = MaterialTheme.typography.bodyMedium,
                color = color,
                fontWeight = FontWeight.Bold
            )
        }
        if (!preference.comment.isNullOrBlank()) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(
                    Icons.AutoMirrored.Filled.Message,
                    null,
                    tint = Color.White.copy(alpha = 0.6f),
                    modifier = Modifier.size(14.dp)
                )
                Spacer(Modifier.width(6.dp))
                Text(
                    text = preference.comment ?: "",
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.White.copy(alpha = 0.75f)
                )
            }
        }
    }
}

/**
 * One line for the person picker (SH-75): "Available (Morning) · “From 8:00”" in green,
 * "Unavailable · …" in red, or "No availability given".
 */
@Composable
fun AvailabilityLine(preference: DayPreference?, availabilitySlots: List<AvailabilitySlot>) {
    if (preference == null) {
        Text(
            stringResource(Res.string.roster_availability_no_answer),
            style = MaterialTheme.typography.labelSmall,
            color = OnDialog.onSurfaceVariant
        )
        return
    }
    val slotLabel = availabilitySlots.find { it.id == preference.preferredSlotId }?.label
    val available = preference.status == AvailabilityStatus.AVAILABLE
    val text = buildString {
        append(preference.status.label())
        if (available && slotLabel != null) append(" ($slotLabel)")
        preference.comment?.takeIf { it.isNotBlank() }?.let { append(" · “$it”") }
    }
    Text(
        text,
        style = MaterialTheme.typography.labelSmall,
        color = if (available) Color(0xFF81C784) else ErrorOnNavy,
        fontWeight = FontWeight.Bold
    )
}

/**
 * SH-112: the month's labour-code warnings, person by person (who, then each rule broken). Soft:
 * the roster can be kept as it is; it only says what the labour code would object to.
 */
@Composable
private fun LabourCodeDialog(state: RosterDetailUiState, onDismiss: () -> Unit) {
    val byUser = state.labourReport.byUserId
    val names = state.availableEmployees.associate { it.uid to it.displayName }
    EvoDialog(
        title = stringResource(Res.string.roster_labour_code_title),
        icon = Icons.Default.Gavel,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.close), onDismiss),
        dismiss = null,
        bodyArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Text(stringResource(Res.string.roster_labour_code_hint), style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.7f))
        if (byUser.isEmpty()) {
            Text(stringResource(Res.string.roster_labour_code_none), style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f))
        }
        byUser.entries.sortedBy { (uid, _) -> names[uid] ?: uid }.forEach { (uid, warnings) ->
            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(names[uid] ?: uid, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White)
                val contract = state.labourProfiles[uid]?.contract ?: com.evoapps.evoshift.domain.model.SystemContractType.NOT_SET
                warnings.forEach { w ->
                    Text("• ${w.text()}", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFFFB74D))
                    // SH-133: the Labour Code for an employee, the company's rule for anyone else.
                    com.evoapps.evoshift.domain.schedule.RosterIssue.Labour(w, contract).basisText()?.let { basis ->
                        Text(basis, style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f), modifier = Modifier.padding(start = 12.dp))
                    }
                }
            }
        }
    }
}

/** SH-167: test tag of the strip over the days ("12 unfilled shifts · Auto-assign"). */
const val UNFILLED_STRIP_TAG = "roster_unfilled_strip"

/**
 * SH-167: how many of a draft's shifts nobody works yet, with auto-assign right beside the count
 * (the top bar's action, which a phone folds into ⋮).
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun UnfilledStrip(
    count: Int,
    onAutoAssign: () -> Unit,
    autoAssignEnabled: Boolean
) {
    FlowRow(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color(0xFFFFF3E0))
            .padding(horizontal = 16.dp, vertical = 8.dp)
            .testTag(UNFILLED_STRIP_TAG),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp),
        itemVerticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            pluralStringResource(Res.plurals.roster_unfilled_count, count, count),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Bold,
            color = Color(0xFFB71C1C),
            modifier = Modifier.padding(end = 4.dp)
        )
        StripButton(stringResource(Res.string.auto_assign), Icons.Default.AutoFixHigh, onAutoAssign, autoAssignEnabled)
    }
}

/** Test tag of the builder's "Import from a spreadsheet" strip (SH-217). */
const val IMPORT_STRIP_TAG = "roster_import_strip"

/** SH-217: the empty draft's offer to import the month from a spreadsheet. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ImportFromSheetStrip(onImport: () -> Unit) {
    FlowRow(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color(0xFFEFF4FB))
            .padding(horizontal = 16.dp, vertical = 8.dp)
            .testTag(IMPORT_STRIP_TAG),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp),
        itemVerticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            stringResource(Res.string.roster_import_empty_hint),
            style = MaterialTheme.typography.bodyMedium,
            color = DeepNavy,
            modifier = Modifier.padding(end = 4.dp)
        )
        StripButton(stringResource(Res.string.roster_import_empty_action), Icons.Default.UploadFile, onImport, true)
    }
}

@Composable
private fun StripButton(label: String, icon: androidx.compose.ui.graphics.vector.ImageVector, onClick: () -> Unit, enabled: Boolean) {
    Button(
        onClick = onClick,
        enabled = enabled,
        modifier = Modifier.handCursor(),
        shape = RoundedCornerShape(8.dp),
        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 6.dp),
        colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White)
    ) {
        Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(6.dp))
        Text(label, fontWeight = FontWeight.Bold, maxLines = 1)
    }
}

/** SH-219: what a roster opened from the start path does first ([com.evoapps.evoshift.Route.RosterDetail.action]). */
object RosterDetailAction {
    const val AUTO_ASSIGN = "auto_assign"
    const val EMAIL = "email"
}

/** SH-227: where the event's name goes in the day menu's "Edit …" label. */
private const val EVENT_NAME_MARK = "{event}"

/** SH-227: the phone day sheet's ⋮ → "Dodaj wydarzenie…". */
const val DAY_SHEET_ADD_EVENT_TAG = "day_sheet_add_event"

/**
 * SH-247: the roster before its month is read: on phones the day list's cards, on wider windows
 * the grid (the day headers across, the people's rows under them), as placeholders.
 */
@Composable
internal fun RosterPlaceholder(modifier: Modifier = Modifier) {
    val compact = LocalWindowWidthClass.current.isCompact
    com.evoapps.evoshift.widgets.SkeletonArea(modifier.fillMaxSize()) {
        if (compact) {
            Column(Modifier.fillMaxWidth().padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                repeat(6) { com.evoapps.evoshift.widgets.SkeletonRowCard(leadingShape = RoundedCornerShape(8.dp)) }
            }
        } else {
            val days = 7
            Column(Modifier.fillMaxWidth().padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Spacer(Modifier.width(160.dp))
                    repeat(days) { com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.weight(1f).height(72.dp)) }
                }
                repeat(5) {
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        com.evoapps.evoshift.widgets.SkeletonListRow(Modifier.width(160.dp), leadingSize = 32.dp)
                        repeat(days) { com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.weight(1f).height(GridRowHeight - 8.dp)) }
                    }
                }
            }
        }
    }
}
